import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

import {
  GetDecryptAccessTokenformat,
  GetDecryptEmailformat,
  GetDecryptReferenceNumberformat,
  SetEncryptAccessTokenformat,
  SetEncryptEmailformat,
  SetEncryptPasswordformat,
  SetEncryptReferenceNumberformat,
  SetEncryptUserNameformat,
  SetUserData,
  GetDecryptUniqId,
} from "../../Components/Common/Common";
import { ResetGlobalStateRequestAuthSlice } from "./RequestsAuthSlice";

const initialState = {
  email: "",
  googleSigninData: [],
  profileDetails: [],
  transactionDetails: null,
  isLoading: false,
  isInsiteDataLoading: true,
  wordsData: [],
  InstagramUserDetails: "",
  InstagramProfileData: "",
  ImageCaptionGenerate: "",
  TokenID: "",
  HashedTokenID: "",
  S3BucketImage: "",
  getUserWalletDetails: "",
  walletBalanceUser: "",
  userPrivateKey: "",
  transactionHistory: [],
  AiAgentResponse: [],
  BillingCostOpenAI: {},
  BillingCostOpenAIAmount: [],
  hasInstaAccess: false,
  ServerDailyCost: {},
  StabilityDiffusion: {},
  userlimitdata: "",
  CostGraph: {},
  userRole: null,
  BillingCostGemini: "",
  profileDetailsAdmin: "",
  AllUserDetails: [],
  encyptData: "",
  UsageLLMUser: [],
  AwsCostUsage: {},
  ALLfaq: [],
  QrcodeDetails: {},
  GetQrcodeDetails: {},
  getuseruniqueId: "",
  userHistory: [],
  tokenExist: "",
  adminTransactionHistory: [],
  subscriptionPlans: [],
  photoList: [],
  activePlan: [],
  MultipleGetNFT: [],
  nftCollectionAssets: [],
  GeminiData: [],
  UserChatSessionIDS: [],
  GooglePhotosData: [],
  tikTokTokenExist: "",
  GoogletokenExist: "",
  SearchTopicData: [],
  getPromptSuggestion: null,
  GetTiktokMediaRecordData: null,
  SolanaTransactionHistoryValues: null,
  SolanaWallet: null,
  SolanaWalletBalance: null,
  Dataredirect: null,
  ApiStatus: null,
  OpenAiLimit: null,
  CostGraphOpenAi: null,
  StabilityLimit: null,
  CostGraphStability: null,
  GeminiLimit: null,
  CostGraphGemini: null,
  BillingCostLLM: null,
  DashboardCardCost: null,
  DashboardGraph: null,
  gettiktokuserdetails: null,
  prwprice: null,
  emailExistGoogleSignin: null,
  WeePointData: [],
  ListallDraftEmails: [],
  CreditTRansactions: [],
  CreditUsage: null,
  GetCalenderData: [],
  getuserallbadges: [],
};

const location = window.location;

export const globalSlice = createSlice({
  name: "globalSlice",
  initialState,
  reducers: {
    HandleEmaildata: (state, actions) => {
      state.email = actions?.payload;
    },
    HandleCalenderData: (state, actions) => {
      state.GetCalenderData = actions?.payload;
    },
    HandleAICreditUsage: (state, actions) => {
      state.CreditUsage = actions?.payload;
    },
    HandleAICreditTransactions: (state, actions) => {
      state.CreditTRansactions = actions?.payload;
    },
    HandleAllGetUserBadgesDetails: (state, actions) => {
      state.getuserallbadges = actions?.payload;
    },
    HandleWeePointData: (state, actions) => {
      state.WeePointData = actions?.payload;
    },
    HandleGoogleDraft: (state, actions) => {
      state.ListallDraftEmails = actions?.payload;
    },
    HandleCheckGmailExist: (state, actions) => {
      state.emailExistGoogleSignin = actions?.payload;
    },
    HandleSeachGeminiDatabyTopic: (state, actions) => {
      state.SearchTopicData = actions?.payload;
    },
    HandleGeminiDataPromptSuggestion: (state, actions) => {
      state.getPromptSuggestion = actions?.payload;
    },
    HandleGeminiData: (state, actions) => {
      state.GeminiData = actions?.payload;
    },
    GetTiktokToken: (state, actions) => {
      state.tikTokTokenExist = actions?.payload;
    },
    HandleUserChatSessionID: (state, actions) => {
      state.UserChatSessionIDS = actions?.payload;
    },
    TiktokMediaRecord: (state, actions) => {
      state.GetTiktokMediaRecordData = actions?.payload;
    },
    HandleGooglePhotosData: (state, actions) => {
      state.GooglePhotosData = actions?.payload;
    },

    GetMultipleNftMinted: (state, actions) => {
      state.MultipleGetNFT = actions?.payload;
    },
    HandleNFTMInted: (state, actions) => {
      state.MintedNft = actions?.payload;
    },
    SolanaTransactionHistoryData: (state, actions) => {
      state.SolanaTransactionHistoryValues = actions?.payload;
    },
    HandleSubscriptionPlans: (state, actions) => {
      state.subscriptionPlans = actions?.payload;
    },
    HandleGoogleSigninData: (state, actions) => {
      state.googleSigninData = actions?.payload;
    },
    HandleStoreUserHistory: (state, actions) => {
      state.userHistory = actions?.payload;
    },
    HandleAdminTransactionHistory: (state, actions) => {
      state.adminTransactionHistory = actions?.payload;
    },
    GetUserSolanaDetail: (state, actions) => {
      state.SolanaWallet = actions?.payload;
    },
    GetUserSolanaDetailBalance: (state, actions) => {
      state.SolanaWalletBalance = actions?.payload;
    },
    HandleProfileDetails: (state, actions) => {
      state.profileDetails = actions?.payload;
    },
    HandleProfileDetailsAdmin: (state, actions) => {
      state.profileDetailsAdmin = actions?.payload;
    },
    HandleQrCode: (state, actions) => {
      state.QrcodeDetails = actions?.payload;
    },
    GetHandleQrCode: (state, actions) => {
      state.GetQrcodeDetails = actions?.payload;
    },
    SetLoading: (state, actions) => {
      state.isLoading = actions?.payload;
    },
    SetDataurl: (state, actions) => {
      state.Dataredirect = actions?.payload;
    },
    HandleAllFaq: (state, actions) => {
      state.ALLfaq = actions?.payload;
    },
    SetBillingCostOpenAI: (state, actions) => {
      state.BillingCostOpenAI = actions?.payload;
    },
    UpdateApiStatus: (state, actions) => {
      state.ApiStatus = actions?.payload;
    },
    SetBillingCostGemini: (state, actions) => {
      state.BillingCostGemini = actions?.payload;
    },
    HandleSetBillingCostOpenAI: (state, actions) => {
      state.BillingCostOpenAIAmount = actions?.payload;
    },
    HandleMaildata: (state, actions) => {
      state.wordsData = actions?.payload;
    },
    HandleAiagentdata: (state, actions) => {
      state.AiAgentResponse = actions?.payload;
    },
    HandleWalletDetails: (state, actions) => {
      state.getUserWalletDetails = actions?.payload;
    },
    HandleUserPrivatekeyDetails: (state, actions) => {
      state.userPrivateKey = actions?.payload;
    },
    HandleWalletBalance: (state, actions) => {
      state.walletBalanceUser = actions?.payload;
    },

    HandleInstagramUserData: (state, actions) => {
      state.InstagramUserDetails = actions?.payload;
    },

    HandleUpdateHasInstaAccess: (state, actions) => {
      state.hasInstaAccess = actions?.payload;
    },
    HandleUpdateUserRole: (state, actions) => {
      state.userRole = actions?.payload;
    },

    HandleTransactionHistory: (state, actions) => {
      state.transactionHistory = actions?.payload;
    },

    HandleInstagramUserProfileData: (state, actions) => {
      state.InstagramProfileData = actions?.payload;
    },
    HandleImageCaptionGenerate: (state, actions) => {
      state.ImageCaptionGenerate = actions?.payload;
    },

    HandleTokenIdGenerate: (state, actions) => {
      state.TokenID = actions?.payload;
    },
    HandleHashedTokenId: (state, actions) => {
      state.HashedTokenID = actions?.payload;
    },
    HandleS3BucketImage: (state, actions) => {
      state.S3BucketImage = actions?.payload;
    },
    SetInsiteLoading: (state, actions) => {
      state.isInsiteDataLoading = actions?.payload;
    },
    HandleServerDailyCost: (state, action) => {
      state.ServerDailyCost = action?.payload;
    },
    HandleStabilityDiffusionCost: (state, action) => {
      state.StabilityDiffusion = action?.payload;
    },
    HandleTransactionDetails: (state, action) => {
      state.transactionDetails = action.payload;
    },
    HandleUserlimit: (state, action) => {
      state.userlimitdata = action?.payload;
    },
    HandlegetServerCostGraph: (state, action) => {
      state.CostGraph = action?.payload;
    },
    HandleGetOpenAiLimit: (state, action) => {
      state.OpenAiLimit = action?.payload;
    },
    HandlegetOpenAiCostGraph: (state, action) => {
      state.CostGraphOpenAi = action?.payload;
    },
    HandleGetUserStabilityDiffusionLimitSet: (state, action) => {
      state.StabilityLimit = action?.payload;
    },
    HandlegetStabilityCostGraph: (state, action) => {
      state.CostGraphStability = action?.payload;
    },
    HandleGeminiLimit: (state, action) => {
      state.GeminiLimit = action?.payload;
    },
    HandlegetGeminiCostGraph: (state, action) => {
      state.CostGraphGemini = action?.payload;
    },
    HandleAwsDetailsData: (state, action) => {
      state.AwsCostUsage = action?.payload;
    },
    UpdateBillingCost: (state, action) => {
      state.BillingCostLLM = action?.payload;
    },
    HandleAllUserDetails: (state, action) => {
      state.AllUserDetails = action?.payload;
    },
    HandleUpdateEncypt: (state, action) => {
      state.encyptData = action?.payload;
    },
    UpdateCost: (state, action) => {
      state.DashboardCardCost = action?.payload;
    },
    AdminDashboard: (state, action) => {
      state.DashboardGraph = action?.payload;
    },
    HandleLLMUserData: (state, action) => {
      state.UsageLLMUser = action?.payload;
    },
    GetHandleQrCodeUniqueId: (state, action) => {
      state.getuseruniqueId = action?.payload;
    },
    GetTiktokUserData: (state, action) => {
      state.gettiktokuserdetails = action?.payload;
    },
    GetTokenExist: (state, action) => {
      state.tokenExist = action?.payload;
    },
    HandleTokenExist: (state, action) => {
      state.GoogletokenExist = action?.payload;
    },
    HandlePhotoList: (state, action) => {
      state.photoList = action.payload;
    },
    HandleActivePlan: (state, action) => {
      state.activePlan = action.payload;
    },
    HandleNftCollectionAssets: (state, action) => {
      state.nftCollectionAssets = action.payload;
    },
    HandlePRWPrice: (state, action) => {
      state.prwprice = action.payload;
    },
    // Add a logout/reset reducer
    ResetGlobalState: () => initialState,
  },
});

export const {
  HandleAllGetUserBadgesDetails,
  HandleCalenderData,
  HandleAICreditTransactions,
  HandleAICreditUsage,
  HandleWeePointData,
  HandleCheckGmailExist,
  ResetGlobalState,
  HandlePRWPrice,
  HandleSeachGeminiDatabyTopic,
  HandleEmaildata,
  HandleGeminiDataPromptSuggestion,
  GetTiktokToken,
  HandleUserChatSessionID,
  HandleGeminiData,
  UpdateCost,
  TiktokMediaRecord,
  GetTokenExist,
  SolanaTransactionHistoryData,
  GetTiktokUserData,
  AdminDashboard,
  HandleUpdateEncypt,
  HandleAllUserDetails,
  HandleS3BucketImage,
  HandleGoogleSigninData,
  HandleProfileDetails,
  HandleUpdateHasInstaAccess,
  SetLoading,
  GetUserSolanaDetailBalance,
  HandleMaildata,
  HandleInstagramUserData,
  HandleHashedTokenId,
  HandleTokenIdGenerate,
  HandleWalletBalance,
  HandleStoreUserHistory,
  HandleWalletDetails,
  HandleImageCaptionGenerate,
  HandleUpdateUserRole,
  HandleTransactionHistory,
  HandleUserPrivatekeyDetails,
  SetBillingCostOpenAI,
  HandleSetBillingCostOpenAI,
  HandleStabilityDiffusionCost,
  HandleUserlimit,
  HandleInstagramUserProfileData,
  HandlegetServerCostGraph,
  SetBillingCostGemini,
  HandleGetOpenAiLimit,
  HandlegetOpenAiCostGraph,
  HandleGetUserStabilityDiffusionLimitSet,
  HandlegetStabilityCostGraph,
  HandleGeminiLimit,
  HandlegetGeminiCostGraph,
  SetLLMError,
  HandleProfileDetailsAdmin,
  HandleLLMUserData,
  HandleAwsDetailsData,
  HandleAllFaq,
  HandleQrCode,
  GetHandleQrCode,
  GetHandleQrCodeUniqueId,
  HandleSubscriptionPlans,
  HandleTokenExist,
  HandlePhotoList,
  HandleActivePlan,
  GetUserSolanaDetail,
  HandleNFTMInted,
  GetMultipleNftMinted,
  HandleTransactionDetails,
  HandleNftCollectionAssets,
  HandleGoogleDraft,
} = globalSlice.actions;

export default globalSlice.reducer;

// let isRefreshing = false; // global flag

// ***********************************USER AUTHENTICATION****************************************************

// export function ReGenerateToken(ApiFunction, body, dispatch) {
//   return async () => {

//      if (isRefreshing) return; // prevent multiple calls
//     isRefreshing = true;
//     try {
//       SetLoading(true);
//       let url = `${process.env.REACT_APP_apiBaseUrl}/api/v1/refreshAccessToken`;
//       const data = {
//         email: GetDecryptEmailformat() || localStorage?.getItem("email"),
//         reference_number: GetDecryptReferenceNumberformat() || localStorage?.getItem("reference_number"),
//       };
//       const response = await axios.post(url, data);

//       if (response?.data) {
//         SetLoading(false);

//         SetEncryptAccessTokenformat(response?.data?.access_token);
//         if (ApiFunction) {
//          await dispatch(ApiFunction(body));
//         }
//         return response?.data;
//       }
//     } catch (error) {
//       toast.error(error?.response?.data?.message);
//       SetLoading(false);
//     } finally {
//       SetLoading(false);
//     }
//   };
// }

// export function ReGenerateToken(ApiFunction, body, dispatch) {
//   return async () => {
//     if (isRefreshing) return; // prevent multiple calls
//     isRefreshing = true;

//     try {
//       dispatch(SetLoading(true));

//       const url = `${process.env.REACT_APP_apiBaseUrl}/api/v1/refreshAccessToken`;
//       const data = {
//         email: GetDecryptEmailformat() || localStorage?.getItem("email"),
//         reference_number: GetDecryptReferenceNumberformat() || localStorage?.getItem("reference_number"),
//       };

//       const response = await axios.post(url, data);

//       if (response?.data?.access_token) {
//         SetEncryptAccessTokenformat(response.data.access_token);

//         // retry the failed API once
//         if (ApiFunction) {

//           await dispatch(ApiFunction(body));
//         }
//       } else {
//         toast.error("Failed to refresh token");
//       }
//     } catch (error) {
//       toast.error(error?.response?.data?.message || "Session expired, please login again.");
//       // optionally redirect to login
//     } finally {
//       dispatch(SetLoading(false));
//       isRefreshing = false; // reset flag
//     }
//   };
// }

// old
// export function ReGenerateToken(ApiFunction, body, dispatch) {
//   return async () => {
//     // if (isRefreshing) return; // prevent multiple calls
//     // isRefreshing = true;

//     try {
//       dispatch(SetLoading(true));

//       const url = `${process.env.REACT_APP_apiBaseUrl}/api/v1/rotateRefreshToken`;

//       const data = {
//         email: GetDecryptEmailformat() || localStorage?.getItem("email"),
//         old_refresh_token: localStorage?.getItem("refreshtoken"),
//       };

//       const response = await axios.post(url, data);

//       if (response?.data?.access_token) {
//         SetEncryptAccessTokenformat(response.data.access_token);

//         // retry the failed API once
//         if (ApiFunction) {
//           await dispatch(ApiFunction(body));
//         }
//       } else {
//         toast.error("Failed to refresh token");
//       }
//     } catch (error) {
//       toast.error(error?.response?.data?.message || "Session expired, please login again.");
//       // optionally redirect to login
//     } finally {
//       dispatch(SetLoading(false));
//       // isRefreshing = false; // reset flag
//     }
//   };
// }

// new
export function ReGenerateToken(ApiFunction, body, dispatch) {
  return async () => {
    // if (isRefreshing) return; // prevent multiple calls
    // isRefreshing = true;

    try {
      dispatch(SetLoading(true));

      const url = `${process.env.REACT_APP_apiBaseUrl}/auth/api/v1/refreshAccessToken`;

      const data = {
        email: GetDecryptEmailformat() || localStorage?.getItem("email"),
        reference_number:
          GetDecryptReferenceNumberformat() ||
          localStorage?.getItem("reference_number"),
        // old_refresh_token: localStorage?.getItem("refreshtoken"),
      };

      const response = await axios.post(url, data);

      if (response?.data?.access_token) {
        SetEncryptAccessTokenformat(response.data.access_token);

        // retry the failed API once
        if (ApiFunction) {
          return await dispatch(ApiFunction(body));
        }
      } else {
        toast.error("Failed to refresh token");
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Session expired, please login again."
      );
      // optionally redirect to login
    } finally {
      dispatch(SetLoading(false));
      // isRefreshing = false; // reset flag
    }
  };
}

export function LoginHandler({ data, navigate, dispatch }) {
  return async () => {
    try {
      dispatch(SetLoading(true));
      let url = `${process.env.REACT_APP_apiBaseUrl}/api/v1/googleSignIn`;
      const response = await axios.post(url, data);
      if (response?.data) {
        const email = response?.data?.data[0].email;
        dispatch(CheckGmailExist({ email })).then((res) => {
          if (res.email_exist === false) {
            dispatch(
              globalSlice?.actions?.HandleCheckGmailExist(res.email_exist)
            );
          }
        });

        // return;

        dispatch(SetLoading(false));
        SetEncryptEmailformat(response?.data?.data[0].email);
        SetEncryptReferenceNumberformat(
          response?.data?.data[0]?.reference_number
        );
        SetEncryptAccessTokenformat(response?.data?.access_token);
        localStorage.setItem("refreshtoken", response?.data?.refresh_token);
        SetUserData(response?.data?.data[0]?.username);
        dispatch(
          globalSlice?.actions?.HandleEmaildata(response?.data?.data[0].email)
        );
        dispatch(
          globalSlice?.actions.HandleGoogleSigninData(response?.data?.data)
        );

        // calling user logs API

        dispatch(PostClientSideLogs());
        if (response?.data?.data[0]?.email_verified === 0) {
          navigate("/verifyotp");
        } else if (response?.data?.data[0]?.phone_verified === 0) {
          navigate("/otp");
        } else {
          dispatch(globalSlice?.actions?.HandleUpdateUserRole("USER"));
          navigate("/dashboard");
        }
      }
    } catch (error) {
      if (
        error.response.data?.message ===
        "Login has failed. Email has not been verified."
      ) {
        dispatch(
          globalSlice?.actions.HandleGoogleSigninData(
            error?.response?.data?.data
          )
        );
        SetEncryptEmailformat(error?.response?.data?.data[0]?.email);
        SetEncryptReferenceNumberformat(
          error?.response?.data?.data[0]?.reference_number
        );
        SetEncryptAccessTokenformat(error?.response?.data?.access_token);
        SetUserData(error?.response?.data?.data[0]?.username);

        if (error.response?.data?.data[0]?.email_verified === 0) {
          navigate("/verifyotp");
        } else if (error?.response?.data?.data[0]?.phone_verified === 0) {
          navigate("/otp");
        } else {
          navigate("/dashboard");
          dispatch(globalSlice?.actions?.HandleUpdateUserRole("USER"));
        }
      } else {
        toast.error(error?.response?.data?.message);
      }
      toast.error(error?.response?.data?.message);
      dispatch(SetLoading(false));
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function RegisterUser({ registerData, dispatch, callback, navigate }) {
  return async () => {
    try {
      dispatch(SetLoading(true));

      let url = `${process.env.REACT_APP_apiBaseUrl}/api/v1/signUp`;
      const response = await axios.post(url, registerData);
      if (response?.data?.success === true) {
        dispatch(SetLoading(false));
        toast.success("Sign Up successfully!");
        if (response?.data?.error) {
          toast.info(response?.data?.message);
        }

        if (callback) callback(response?.data);

        navigate("/");
        return response?.data;
      } else {
        dispatch(SetLoading(false));

        return response?.data;
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
      dispatch(SetLoading(false));
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

// old one
// export function LoginUser({ loginData, navigate, dispatch, Callback }) {
//   return async () => {
//     try {
//       let email = GetDecryptEmailformat();

//       dispatch(SetLoading(true));
//       let url = `${process.env.REACT_APP_apiBaseUrl}/api/v1/signIn`;

//       const response = await axios.post(url, loginData);
//       if (response?.data) {
//         dispatch(SetLoading(false));
//         dispatch(globalSlice?.actions.HandleGoogleSigninData(response?.data?.data));
//         SetEncryptEmailformat(response?.data?.data[0].email);
//         SetEncryptReferenceNumberformat(response?.data?.data[0]?.reference_number);
//         SetEncryptAccessTokenformat(response?.data?.access_token);
//         localStorage.setItem("refreshtoken", response?.data?.refresh_token);

//         SetUserData(response?.data?.data[0]?.username);
//         toast.success("Sign In successfully!");
//         if (Callback) {
//           setTimeout(() => {
//             if (email) {
//               Callback();
//             }
//           }, 1000);
//         }
//         if (response?.data?.data[0]?.email_verified === 0) {
//           navigate("/verifyotp");
//         } else if (response?.data?.data[0]?.phone_verified === 0) {
//           navigate("/otp");
//         } else {
//           navigate("/dashboard");
//           dispatch(globalSlice?.actions?.HandleUpdateUserRole("USER"));
//         }
//         return response?.data;
//       }
//     } catch (error) {
//       if (error.response.data?.message === "Login has failed. Email has not been verified.") {
//         dispatch(globalSlice?.actions.HandleGoogleSigninData(error?.response?.data?.data));
//         SetEncryptEmailformat(error?.response?.data?.data[0]?.email);
//         SetEncryptReferenceNumberformat(error?.response?.data?.data[0]?.reference_number);
//         SetEncryptAccessTokenformat(error?.response?.data?.access_token);
//         SetUserData(error?.response?.data?.data[0]?.username);

//         if (error.response?.data?.data[0]?.email_verified === 0) {
//           navigate("/verifyotp");
//         } else if (error?.response?.data?.data[0]?.phone_verified === 0) {
//           navigate("/otp");
//         } else {
//           navigate("/dashboard");
//           dispatch(globalSlice?.actions?.HandleUpdateUserRole("USER"));
//         }
//       } else {
//         toast.error(error?.response?.data?.message);
//       }
//       dispatch(SetLoading(false));
//     } finally {
//       dispatch(SetLoading(false));
//     }
//   };
// }

// new one
export function LoginUser({ loginData, navigate, dispatch, Callback }) {
  return async () => {
    try {
      let email = GetDecryptEmailformat();

      dispatch(SetLoading(true));
      let url = `${process.env.REACT_APP_apiBaseUrl}/auth/api/v1/signIn`;

      const response = await axios.post(url, loginData);
      if (response?.data) {
        dispatch(SetLoading(false));
        dispatch(
          globalSlice?.actions.HandleGoogleSigninData(response?.data?.data)
        );
        SetEncryptEmailformat(response?.data?.data[0].email);
        SetEncryptReferenceNumberformat(
          response?.data?.data[0]?.reference_number
        );
        SetEncryptAccessTokenformat(response?.data?.access_token);
        localStorage.setItem("refreshtoken", response?.data?.refresh_token);
        SetUserData(response?.data?.data[0]?.username);

        // calling user logs API
        dispatch(PostClientSideLogs());

        toast.success("Sign In successfully!");
        if (Callback) {
          setTimeout(() => {
            if (email) {
              Callback();
            }
          }, 1000);
        }
        if (response?.data?.data[0]?.email_verified === false) {
          navigate("/verifyotp");
        } else if (response?.data?.data[0]?.phone_verified === false) {
          navigate("/otp");
        } else {
          navigate("/dashboard");
          dispatch(globalSlice?.actions?.HandleUpdateUserRole("USER"));
        }
        return response?.data;
      }
    } catch (error) {
      if (
        error.response.data?.message ===
        "Login has failed. Email has not been verified."
      ) {
        dispatch(
          globalSlice?.actions.HandleGoogleSigninData(
            error?.response?.data?.data
          )
        );
        SetEncryptEmailformat(error?.response?.data?.data[0]?.email);
        SetEncryptReferenceNumberformat(
          error?.response?.data?.data[0]?.reference_number
        );
        SetEncryptAccessTokenformat(error?.response?.data?.access_token);
        SetUserData(error?.response?.data?.data[0]?.username);

        if (error.response?.data?.data[0]?.email_verified === 0) {
          navigate("/verifyotp");
        } else if (error?.response?.data?.data[0]?.phone_verified === 0) {
          navigate("/otp");
        } else {
          navigate("/dashboard");
          dispatch(globalSlice?.actions?.HandleUpdateUserRole("USER"));
        }
      } else {
        toast.error(error?.response?.data?.message);
      }
      dispatch(SetLoading(false));
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function LogoutHandler({ obj, navigate, dispatch, socket }) {
  const token = GetDecryptAccessTokenformat();

  const uniqId = GetDecryptUniqId();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return async () => {
    try {
      dispatch(SetLoading(true));

      // const email = GetDecryptEmailformat();
      // const referenceNumber = GetDecryptReferenceNumberformat();
      // if (email && referenceNumber) {
      //   try {
      //     const instaRevokeResponse = await axios.post(`${process.env.REACT_APP_apiBaseUrl}/api/v1/revoke/instagram`, { email, reference_number: referenceNumber }, reqoptions);
      //     if (instaRevokeResponse?.data?.success) {
      //     }
      //   } catch (revokeError) {
      //     console.error("Failed to revoke Instagram access:", revokeError?.response?.data?.message);
      //   }
      // }

      let url = `${process.env.REACT_APP_apiBaseUrl}/api/v1/signOut`;
      const response = await axios.post(url, obj, reqoptions);
      if (response?.data) {
        dispatch(SetLoading(false));

        if (socket) {
          socket.emit("logout", {
            uniqueId: uniqId,
          });

          socket.emit("logoutFromWeb", {
            uniqueId: uniqId,
          });
        }

        sessionStorage.clear();
        localStorage?.clear();

        dispatch(globalSlice.actions.ResetGlobalState());
        dispatch(ResetGlobalStateRequestAuthSlice());

        toast.success(response?.data?.message);

        navigate("/");
        return response?.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        let body = { obj, navigate, dispatch };
        dispatch(ReGenerateToken(LogoutHandler, body, dispatch));
        return;
      }

      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function AddPhoneNumber({ obj, dispatch, callback }) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return async () => {
    try {
      dispatch(SetLoading(true));
      let url = `${process.env.REACT_APP_apiBaseUrl}/api/v1/addPhoneNumber`;
      const response = await axios.post(url, obj, reqoptions);
      if (response?.data?.success === true) {
        dispatch(SetLoading(false));
        toast.success(response?.data?.data?.message);
        if (callback) callback(response?.data);
        return response?.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        let body = { obj, dispatch, callback };
        dispatch(ReGenerateToken(AddPhoneNumber, body, dispatch));
        return;
      }

      toast.error(
        error?.response?.data?.message === "Invalid phone." &&
          "Invalid phone number"
      );
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function ConfirmEmail({ obj, navigate, dispatch }) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return async () => {
    try {
      dispatch(SetLoading(true));
      let url = `${process.env.REACT_APP_apiBaseUrl}/api/v1/confirmEmail`;
      const response = await axios.post(url, obj, reqoptions);
      if (response?.data) {
        dispatch(SetLoading(false));
        toast.success(response?.data?.message);
        if (localStorage.getItem("isManual")) {
          navigate("/");
          localStorage.removeItem("isManual");
        } else {
          navigate("/otp");
        }
        localStorage.removeItem("isOtpSent");
        return response?.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        let body = { obj, navigate, dispatch };
        dispatch(ReGenerateToken(ConfirmEmail, body, dispatch));
        return;
      }

      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}
export function ResendOTPEmail({ obj, dispatch }) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return async () => {
    try {
      dispatch(SetLoading(true));
      let url = `${process.env.REACT_APP_apiBaseUrl}/api/v1/requestEmailOtp`;
      const response = await axios.post(url, obj, reqoptions);
      if (response?.data) {
        toast.success(response?.data?.message);
        dispatch(SetLoading(false));
        return response?.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        let body = { obj, dispatch };
        dispatch(ReGenerateToken(ResendOTPEmail, body, dispatch));
        return;
      }

      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function VerifiedPhone({ obj, navigate, dispatch }) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return async () => {
    try {
      dispatch(SetLoading(true));
      let url = `${process.env.REACT_APP_apiBaseUrl}/api/v1/verifyPhoneNumber`;
      const response = await axios.post(url, obj, reqoptions);
      if (response?.data) {
        dispatch(SetLoading(false));
        navigate("/dashboard");
        return response?.data;
      }
    } catch (error) {
      if (dispatch) {
        dispatch(SetLoading(false));
      }
    }
  };
}

export function UpdateProfile({ obj, navigate, dispatch, callback }) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return async () => {
    try {
      dispatch(SetLoading(true));
      let url = `${process.env.REACT_APP_apiBaseUrl}/api/v1/updateUserProfile`;
      const response = await axios.patch(url, obj, reqoptions);
      if (response?.data) {
        dispatch(SetLoading(false));
        dispatch(GetProfile({ dispatch, obj }));
        toast.success(response?.data?.message);
        if (callback) {
          dispatch(callback(response.data));
        }
        return response?.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        let body = { obj, navigate, dispatch, callback };
        return dispatch(ReGenerateToken(UpdateProfile, body, dispatch));
      }

      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function GetProfile({ obj }) {
  const token = GetDecryptAccessTokenformat();

  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return async (dispatch) => {
    try {
      if (location.pathname === "/profile") {
        dispatch(SetLoading(true));
      }

      let url = `${process.env.REACT_APP_apiBaseUrl}/api/v1/getUserProfile?reference_number=${obj?.reference_number}&email=${obj?.email}`;
      const response = await axios.get(url, reqoptions);
      if (response?.data) {
        dispatch(SetLoading(false));
        dispatch(
          globalSlice?.actions?.HandleProfileDetails(response?.data?.data)
        );
        dispatch(globalSlice?.actions?.HandleUpdateUserRole("USER"));
        return response?.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        let body = { obj, dispatch };
        dispatch(ReGenerateToken(GetProfile, body, dispatch));
        return;
      }

      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function RequestEmailOtp({ obj, dispatch }) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return async () => {
    try {
      dispatch(SetLoading(true));
      let url = `${process.env.REACT_APP_apiBaseUrl}/api/v1/requestEmailOtp`;
      const response = await axios.post(url, obj, reqoptions);
      if (response?.data) {
        dispatch(SetLoading(false));
        localStorage.setItem("isOtpSent", true);
        toast.success(response?.data?.message);
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.data?.message && error?.response?.data?.success) {
        toast.success(error?.response?.data?.message);
      } else {
        toast.error(error?.message);
      }
      if (dispatch) {
        dispatch(SetLoading(false));
      }
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function ChangePassWord({ obj }) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      dispatch(SetLoading(true));

      let url = `${process.env.REACT_APP_apiBaseUrl}/api/v1/changePassword`;

      const response = await axios.post(url, obj, reqoptions);

      if (response?.data?.success === true) {
        toast.success(response?.data?.message);

        dispatch(SetLoading(false));

        return response.data;
      }
    } catch (error) {
      SetLoading(false);
      if (error?.response?.status === 401) {
        let body = { obj, dispatch };
        dispatch(ReGenerateToken(ChangePassWord, body, dispatch));
        return;
      }

      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function ForgotPasswordEmailOtp({ obj, navigate }) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      dispatch(SetLoading(true));

      let url = `${process.env.REACT_APP_apiBaseUrl}/api/v1/forgotPasswordEmailOtp`;

      const response = await axios.post(url, obj, reqoptions);

      if (response?.data?.success === true) {
        sessionStorage.setItem("email", response?.data?.data[0]?.email);
        sessionStorage.setItem(
          "reference_number",
          response?.data?.data[0]?.reference_number
        );
        sessionStorage.setItem("access_token", response?.data?.access_token);
        toast.success(response?.data?.message);
        navigate("/resetpassword");
        dispatch(SetLoading(false));

        return response.data;
      }
    } catch (error) {
      SetLoading(false);
      if (error?.response?.status === 401) {
        let body = { obj, dispatch, navigate };
        dispatch(ReGenerateToken(ForgotPasswordEmailOtp, body, dispatch));
        return;
      }

      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function ResetPasswordApi({ obj, navigate }) {
  const token = sessionStorage.getItem("access_token");
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      dispatch(SetLoading(true));

      let url = `${process.env.REACT_APP_apiBaseUrl}/api/v1/forgotPassword`;

      const response = await axios.post(url, obj, reqoptions);

      if (response?.data?.success === true) {
        sessionStorage.removeItem("email");
        sessionStorage.removeItem("reference_number");
        sessionStorage.removeItem("token");
        toast.success(response?.data?.message);
        navigate("/");
        dispatch(SetLoading(false));

        return response.data;
      }
    } catch (error) {
      SetLoading(false);
      if (error?.response?.status === 401) {
        let body = { obj, dispatch, navigate };
        dispatch(ReGenerateToken(ResetPasswordApi, body, dispatch));
        return;
      }

      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function UploadProfilePicture({
  objforupdatepic,
  dispatch,
  obj,
  refreshProfile = true,
}) {
  const token = GetDecryptAccessTokenformat();
  const formData = new FormData();
  formData.append("email", objforupdatepic?.email);
  formData.append("reference_number", objforupdatepic?.reference_number);
  formData.append("image", objforupdatepic?.image);

  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  };

  return async () => {
    try {
      dispatch(SetLoading(true));
      const url = `${process.env.REACT_APP_apiBaseUrl}/api/v1/uploadUserProfilePicture`;
      const response = await axios.post(url, formData, reqoptions);

      if (response?.data) {
        dispatch(SetLoading(false));
        if (refreshProfile) {
          dispatch(GetProfile({ dispatch, obj }));
        }
        return response?.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        const body = { objforupdatepic, dispatch, obj, refreshProfile };
        return dispatch(
          ReGenerateToken(UploadProfilePicture, body, dispatch)
        );
      }

      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

// *******************************************************************************************************

// ************************************************INSTAGRAM HANDLER*************************************

export function AllowInstagramAccess({ email, referenceNumber, dispatch }) {
  let obj = {
    email: email,
    reference_number: referenceNumber,
  };
  const token = GetDecryptAccessTokenformat();
  return async () => {
    const reqoptions = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    try {
      dispatch(SetLoading(true));
      let url = `${process.env.REACT_APP_apiBaseUrl}/api/v1/instagramTokenExist`;

      const response = await axios.post(url, obj, reqoptions);

      dispatch(SetLoading(false));
      if (response?.data?.success) {
        dispatch(
          globalSlice?.actions?.GetTokenExist(response?.data?.token_exist)
        );
        dispatch(
          GetInstagramDetails({
            email: obj?.email,
            referenceNumber: obj?.reference_number,
            dispatch,
          })
        );
        dispatch(
          GetMqMessage({
            email: obj?.email,
            referenceNumber: obj?.reference_number,
            dispatch,
          })
        );
        dispatch(
          GetInstagramUserDetailsInfo({
            email: obj?.email,
            referenceNumber: obj?.reference_number,
            dispatch,
          })
        );
        return response?.data;
      }
    } catch (error) {
      dispatch(
        globalSlice?.actions?.GetTokenExist(error.response?.data?.token_exist)
      );
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        const body = { email, referenceNumber, dispatch };
        dispatch(ReGenerateToken(AllowInstagramAccess, body, dispatch));
        return;
      }
      // toast.error(error.response?.data?.message || "An error occurred");
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function InstagramHandler({ obj, dispatch }) {
  const token = GetDecryptAccessTokenformat();

  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };
  return async () => {
    try {
      dispatch(SetLoading(true));
      let url = `${process.env.REACT_APP_apiBaseUrl}/api/v1/auth/instagram`;
      const response = await axios.post(url, obj, reqoptions);

      if (response?.data) {
        dispatch(SetLoading(false));
        if (response?.data?.success === true) {
          toast.success(response?.data?.message);

          const authWindow = window.open(
            response?.data?.data,
            "AreaX",
            "height=500,width=500,left=450,top=100"
          );

          const checkWindowClosed = setInterval(() => {
            if (authWindow.closed) {
              clearInterval(checkWindowClosed);
              dispatch(
                GetInstagramDetails({
                  email: obj?.email,
                  referenceNumber: obj?.reference_number,
                  dispatch,
                })
              );
              dispatch(
                GetMqMessage({
                  email: obj?.email,
                  referenceNumber: obj?.reference_number,
                  dispatch,
                })
              );
              dispatch(
                GetInstagramUserDetailsInfo({
                  email: obj?.email,
                  referenceNumber: obj?.reference_number,
                  dispatch,
                })
              );
              dispatch(
                AllowInstagramAccess({
                  email: obj?.email,
                  referenceNumber: obj?.reference_number,
                  dispatch,
                })
              );
              // window.location.reload();
            }
          }, 500);
        } else {
          toast.error(response?.data?.message);
        }

        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        const body = { obj, dispatch };
        dispatch(ReGenerateToken(InstagramHandler, body, dispatch));
        return;
      }
      if (error?.response?.data?.message && error?.response?.data?.success) {
        toast.success(error?.response?.data?.message);
      } else {
        toast.error(error?.response?.data?.message);
      }
      if (dispatch) {
        dispatch(SetLoading(false));
      }
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function UploadPostInstagram({
  instaonchangedata,
  dispatch,
  fileupload,
  email,
  referenceNumber,
  obj,
  TokenID,
  walletBalanceUser,
  getUserWalletDetails,
}) {
  const token = GetDecryptAccessTokenformat();
  return async () => {
    const reqoptions = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    };

    try {
      dispatch(SetLoading(true));
      let url = `${process.env.REACT_APP_apiBaseUrl}/instagram/api/v1/messaging/graph-caption-image`;

      let form_data = new FormData();
      // form_data.append("username", instaonchangedata?.username);
      // form_data.append("password", instaonchangedata?.password);
      form_data.append("email", email);
      form_data.append("reference_number", referenceNumber);
      form_data.append("caption", instaonchangedata?.caption);
      form_data.append("image", fileupload);

      const response = await axios.post(url, form_data, reqoptions);

      if (response?.data?.success === true) {
        dispatch(SetLoading(false));

        SetEncryptUserNameformat(instaonchangedata?.username);
        SetEncryptPasswordformat(instaonchangedata?.password);
        toast.success(response?.data?.message);
        dispatch(globalSlice?.actions?.HandleS3BucketImage(""));
        dispatch(GetInstagramDetails({ email, referenceNumber, dispatch }));
        dispatch(
          GetInstagramUserDetailsInfo({
            obj,
            email,
            referenceNumber,
            dispatch,
            TokenID,
            walletBalanceUser,
            getUserWalletDetails,
          })
        );
        return response?.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        let body = {
          instaonchangedata,
          dispatch,
          fileupload,
          email,
          referenceNumber,
          obj,

          TokenID,
          walletBalanceUser,
          getUserWalletDetails,
        };

        dispatch(ReGenerateToken(UploadPostInstagram, body, dispatch));
        return;
      }
      dispatch(globalSlice?.actions?.HandleS3BucketImage(""));
      toast.error(error.response?.data?.message || "An error occurred");
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function GeneratedCaptionApi({
  email,
  referenceNumber,
  image,
  dispatch,
  obj,
  caption_type,
  custom_type,
}) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  };
  return async () => {
    try {
      dispatch(SetLoading(true));
      // let url = `${process.env.REACT_APP_apiBaseUrl}/api/v1/upload/imageFile`;
      let url = `${process.env.REACT_APP_apiBaseUrlAI}/ai/api/gemini_caption_web`;
      let form_data = new FormData();
      form_data.append("image", image);
      form_data.append("user_reference_number", referenceNumber);
      form_data.append("user_email", email);
      form_data.append("caption_type", caption_type);
      form_data.append("custom_type", custom_type);
      const response = await axios.post(url, form_data, reqoptions);

      if (response?.data?.status === 200) {
        dispatch(SetLoading(false));
        dispatch(UploadToBucket({ obj }));
        dispatch(
          globalSlice?.actions?.HandleImageCaptionGenerate(
            response?.data?.caption
          )
        );

        if (response?.data?.total_cost) {
          let obj = {
            email: email,
            reference_number: referenceNumber,
            total_cost: response?.data?.total_cost,
            service: "GEMINI",
          };
          dispatch(OpenAIandGeminiUserDataSave({ obj, dispatch }));
        }

        return response?.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        const body = {
          email,
          referenceNumber,
          image,
          dispatch,
          obj,
          caption_type,
          custom_type,
        };
        dispatch(ReGenerateToken(GeneratedCaptionApi, body, dispatch));
        return;
      }
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function GetInstagramDetails({ email, referenceNumber, dispatch }) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return async (dispatch) => {
    try {
      dispatch(globalSlice?.actions?.SetInsiteLoading(true));
      dispatch(SetLoading(true));
      let url = `${process.env.REACT_APP_apiBaseUrl}/api/v1/instagramProfileStats?email=${email}&reference_number=${referenceNumber}`;
      dispatch(SetLoading(false));
      dispatch(globalSlice?.actions?.HandleInstagramUserData(null));
      dispatch(globalSlice?.actions?.HandleUpdateHasInstaAccess(null));
      dispatch(globalSlice?.actions?.SetInsiteLoading(false));
      const response = await axios.get(url, reqoptions);

      if (response?.data) {
        dispatch(SetLoading(false));
        dispatch(
          globalSlice?.actions?.HandleInstagramUserData(response?.data?.data)
        );
        dispatch(
          globalSlice?.actions?.HandleUpdateHasInstaAccess(
            response?.data?.success
          )
        );
        dispatch(globalSlice?.actions?.SetInsiteLoading(false));
        return response?.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      dispatch(globalSlice?.actions?.SetInsiteLoading(false));
      if (error?.response?.status === 401) {
        let body = { email, referenceNumber, dispatch };
        dispatch(ReGenerateToken(GetInstagramDetails, body, dispatch));
        return;
      }

      // toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function InstagramRevoke({ obj, dispatch }) {
  const token = GetDecryptAccessTokenformat();

  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return async () => {
    try {
      dispatch(SetLoading(true));
      let url = `${process.env.REACT_APP_apiBaseUrl}/api/v1/revoke/instagram`;
      const response = await axios.post(url, obj, reqoptions);
      if (response?.data) {
        dispatch(SetLoading(false));
        if (response?.data?.success === true) {
          toast.success(response?.data?.message);
          dispatch(
            GetInstagramDetails({
              email: obj?.email,
              referenceNumber: obj?.reference_number,
              dispatch,
            })
          );
          dispatch(
            AllowInstagramAccess({
              email: obj?.email,
              referenceNumber: obj?.reference_number,
              dispatch,
            })
          );
          // window.open(response?.data?.data, "AreaX", "height=500,width=500,left=450,top=100");
          return response.data;
        } else {
          toast.error(response?.data?.message);
        }
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        let body = { obj, dispatch };
        dispatch(ReGenerateToken(InstagramRevoke, body, dispatch));
        return;
      }

      if (error?.response?.data?.message && error?.response?.data?.success) {
        toast.success(error?.response?.data?.message);
      } else {
        toast.error(error?.response?.data?.message);
      }
      if (dispatch) {
        dispatch(SetLoading(false));
      }
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function InstagramLoginDetails({
  obj,
  TokenID,
  getUserWalletDetails,
  walletBalanceUser,
}) {
  return async (dispatch) => {
    try {
      dispatch(SetLoading(true));
      let url = `${process.env.REACT_APP_apiBaseUrl}/instagram/api/v1/messaging/private-user-login`;

      const response = await axios.post(url, obj);

      if (response?.data?.success) {
        toast.success(response?.data?.message);
        SetEncryptUserNameformat(obj?.username);
        SetEncryptPasswordformat(obj?.password);
        dispatch(
          GetInstagramUserDetailsInfo({
            obj,
            dispatch,
            TokenID,
            getUserWalletDetails,
            walletBalanceUser,
          })
        );

        dispatch(SetLoading(false));
        return response.data;
      }
    } catch (error) {
      SetLoading(false);
      if (error?.response?.status === 401) {
        let body = {
          obj,
          dispatch,
          TokenID,
          getUserWalletDetails,
          walletBalanceUser,
        };
        dispatch(ReGenerateToken(InstagramLoginDetails, body, dispatch));
        return;
      }

      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function GetInstagramUserDetailsInfo({
  TokenID,
  getUserWalletDetails,
  walletBalanceUser,
  email,
  referenceNumber,
}) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return async (dispatch) => {
    try {
      dispatch(SetLoading(true));
      dispatch(globalSlice?.actions?.SetInsiteLoading(true));
      let url = `${
        process.env.REACT_APP_apiBaseUrl
      }/api/v1/instagramMediaRecord?reference_number=${
        referenceNumber ? referenceNumber : ""
      }&email=${email ? email : ""}`;
      const response = await axios.get(url, reqoptions);
      if (response?.data?.success) {
        // toast.success(response?.data?.message);
        dispatch(SetLoading(false));
        // SetEncryptUserNameformat(obj?.username);
        // SetEncryptPasswordformat(obj?.password);
        dispatch(
          globalSlice?.actions?.HandleInstagramUserProfileData(
            response?.data?.data
          )
        );
        dispatch(globalSlice?.actions?.SetInsiteLoading(false));

        if (
          walletBalanceUser &&
          walletBalanceUser !==
            "You have not enough balance 0.,please add more balance."
        ) {
          let comment_count = localStorage.getItem("CommentCount") || "200";
          let Multiple_Count = localStorage.getItem("MultipleCount") || "20";
          let isAutoMinting = localStorage.getItem("isAutoMinting");

          let commentMoreThen200 = response?.data?.data?.insights?.filter(
            (item) =>
              item?.comment_count >= Number(comment_count) && !item?.is_minted
          );
          commentMoreThen200 = commentMoreThen200.map((item) => ({
            walletAddress: getUserWalletDetails,
            id: item.media_item_id,
            postUrl: item.share_link,
            platformType: item.share_link.split(".")[1],
            multiple: false,
            txnMethod: "Auto Add Post",
          }));

          const formData = {
            fbUsername: "0",
            instaUsername: "",
            linkedinUsername: "0",
            xUsername: "0",
            fbFollowers: "0",
            instaFollowers: `${response?.data?.data?.followersCount}` || "0",
            linkedinFollowers: "0",
            xFollowers: "0",
            walletAddress: getUserWalletDetails,
            txnMethod: "Auto Add Mint",
          };

          let postMultipledetails = null;
          const hasLength = response?.data?.data?.insights?.length;
          const insightsData = hasLength
            ? response?.data?.data?.insights.slice().reverse()
            : [];
          const lastPost = insightsData?.find(
            (obj) => obj?.is_already_mint_for_multiple !== 0
          );

          let lastCount = 0;
          if (lastPost) {
            lastCount = parseInt(lastPost?.is_already_mint_for_multiple);
          }

          if (
            response?.data?.data?.insights?.length >=
            (lastCount + Number(Multiple_Count) || 20)
          ) {
            const subArray = [
              ...(response?.data?.data?.insights
                ? [...response?.data?.data?.insights]
                : []),
            ].slice(lastCount);
            postMultipledetails = {
              postUrl: subArray.map((item) => item?.share_link),
              platformType: subArray.map(
                (item) => item?.share_link.split(".")[1]
              ),
              multiple: true,
              id: response?.data?.data?.insights[hasLength - 1]?.media_item_id,
              is_already_mint_for_multiple: hasLength,
              walletAddress: getUserWalletDetails,
              txnMethod: "Auto Add Multiple Post",
            };
          }

          if (TokenID && isAutoMinting) {
            if (commentMoreThen200 && commentMoreThen200?.length) {
              const postdetails = commentMoreThen200?.map((item) => ({
                ...item,
                userTokenID: TokenID,
              }));
              dispatch(AddPost({ postdetails, dispatch }));
            }

            if (postMultipledetails) {
              dispatch(
                AddMultiplePost({
                  postMultipledetails: {
                    ...postMultipledetails,
                    userTokenID: TokenID,
                  },
                  dispatch,
                })
              );
            }
            return response?.data;
          }

          if (TokenID) {
            return;
          }

          dispatch(
            AddMinting({
              formData,
              isAutoMinting,
              commentMoreThen200,
              postMultipledetails,
              dispatch,
            })
          );
        } else {
          return response?.data;
        }

        return response?.data;
      }
    } catch (error) {
      dispatch(globalSlice?.actions?.SetInsiteLoading(false));
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        let body = {
          dispatch,
          TokenID,
          getUserWalletDetails,
          walletBalanceUser,
          email,
          referenceNumber,
        };
        dispatch(ReGenerateToken(GetInstagramUserDetailsInfo, body, dispatch));
        return;
      }

      // toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function GetInstagramHashTag({ objhashtag, dispatch }) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async () => {
    try {
      dispatch(SetLoading(true));
      let url = `${process.env.REACT_APP_apiBaseUrl}/instagram/messaging/private-hashtag`;
      const response = await axios.post(url, objhashtag, reqoptions);
      if (response?.data) {
        dispatch(SetLoading(false));
        return response?.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        let body = { objhashtag, dispatch };
        dispatch(ReGenerateToken(GetInstagramHashTag, body, dispatch));
        return;
      }

      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function UploadToBucket({ obj }) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  };
  return async (dispatch) => {
    try {
      dispatch(SetLoading(true));
      // let url = `${process.env.REACT_APP_apiBaseUrl}/api/v1/upload/imageFile`;
      let url = `${process.env.REACT_APP_apiBaseUrl}/api/v1/uploadToBucket`;
      let form_data = new FormData();
      form_data.append("file", obj?.file);
      form_data.append("file_name", obj?.file_name);
      form_data.append("file_type", obj?.file_type);
      const response = await axios.post(url, form_data, reqoptions);

      if (response?.data?.success === true) {
        dispatch(SetLoading(false));
        dispatch(
          globalSlice?.actions?.HandleS3BucketImage(response?.data?.file_url)
        );
        return response?.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        const body = { obj, dispatch };
        dispatch(ReGenerateToken(UploadToBucket, body, dispatch));
        return;
      }
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

// ***************************************************************************************************

// *******************************************GMAIL AUTHENTICATION*************************************

export function GetPhotoList({ email, referenceNumber }) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      dispatch(SetLoading(true));
      const url = `${process.env.REACT_APP_apiBaseUrl}/google-api/photo_list?email=${email}&reference_number=${referenceNumber}`;
      const response = await axios.get(url, reqoptions);

      if (response?.data?.success) {
        dispatch(SetLoading(false));
        dispatch(
          globalSlice?.actions?.HandleGooglePhotosData(response?.data?.data)
        );
        return response.data.data;
      } else {
        dispatch(SetLoading(false));
        // toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      dispatch(globalSlice?.actions?.HandleGooglePhotosData(""));
      // if (error?.response?.status === 401) {
      //   const body = { email, referenceNumber, dispatch };
      //   dispatch(ReGenerateToken(GetPhotoList, body, dispatch));
      //   return;
      // }
      // toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function GetGmailAuth({ obj, dispatch }) {
  const reqoptions = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  return async () => {
    try {
      dispatch(SetLoading(true));
      let url = `${process.env.REACT_APP_apiBaseUrl}/google-api/authorize`;
      const response = await axios.post(url, obj, reqoptions);

      if (response?.data?.success === true) {
        dispatch(SetLoading(false));

        if (response?.data?.message) {
          window.location.href = response?.data?.message;
        }

        return response?.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        let body = { obj, dispatch };
        dispatch(ReGenerateToken(GetGmailAuth, body, dispatch));
        return;
      }

      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function SearchByMailWords({ obj, dispatch }) {
  const token = GetDecryptAccessTokenformat();

  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };
  return async () => {
    try {
      dispatch(SetLoading(true));
      let url = `${process.env.REACT_APP_apiBaseUrl}/google-api/fetch_emails`;
      const response = await axios.post(url, obj, reqoptions);

      if (response?.data?.success === true) {
        dispatch(SetLoading(false));
        dispatch(
          globalSlice?.actions?.HandleMaildata(
            Array.isArray(response?.data?.data) ? response.data.data : []
          )
        );
        return response?.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      // if (error?.response?.status === 401) {
      //   let body = { obj, dispatch };
      //   dispatch(ReGenerateToken(SearchByMailWords, body, dispatch));
      //   return;
      // }

      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}
export function UploadGooglePhotos({
  email,
  referenceNumber,
  image,
  dispatch,
}) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  };
  return async () => {
    try {
      dispatch(SetLoading(true));

      let url = `${process.env.REACT_APP_apiBaseUrl}/google-api/upload_photo`;
      let form_data = new FormData();
      form_data.append("file", image);
      form_data.append("reference_number", referenceNumber);
      form_data.append("email", email);
      const response = await axios.post(url, form_data, reqoptions);

      if (response?.data) {
        dispatch(SetLoading(false));
        dispatch(GetPhotoList({ email, referenceNumber }));

        return response?.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      // if (error?.response?.status === 401) {
      //   const body = { email, referenceNumber, image, dispatch };
      //   dispatch(ReGenerateToken(UploadGooglePhotos, body, dispatch));
      //   return;
      // }
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function RevokeAccess({ email, reference_number, dispatch }) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };

  return async () => {
    try {
      dispatch(SetLoading(true));
      const url = `${process.env.REACT_APP_apiBaseUrl}/google-api/revoke`;
      const response = await axios.post(
        url,
        { email, reference_number },
        reqoptions
      );

      if (response?.data?.success === false) {
        toast.error(response?.data?.message);
      } else {
        dispatch(CheckTokenExist({ email, reference_number, dispatch }));
        toast.success(response?.data?.message);
      }

      dispatch(SetLoading(false));
      return response?.data;
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        const body = { email, reference_number, dispatch };
        dispatch(ReGenerateToken(RevokeAccess, body, dispatch));
        return;
      }
      toast.error(error?.response?.data?.message || "An error occurred");
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function CheckTokenExist({ email, referenceNumber, dispatch }) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async () => {
    try {
      dispatch(SetLoading(true));
      const url = `${process.env.REACT_APP_apiBaseUrl}/google-api/token_exist?email=${email}&reference_number=${referenceNumber}`;
      const response = await axios.get(url, reqoptions);

      if (response?.data) {
        dispatch(SetLoading(false));
        toast.success(response?.data?.message);
        dispatch(globalSlice.actions.HandleTokenExist(response.data?.success));
        return response.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      dispatch(globalSlice.actions.HandleTokenExist(""));
      dispatch(globalSlice?.actions?.HandleGooglePhotosData(""));
      dispatch(globalSlice?.actions?.HandleMaildata(""));
      if (error?.response?.status === 401) {
        const body = { email, referenceNumber, dispatch };
        dispatch(ReGenerateToken(CheckTokenExist, body, dispatch));
        return;
      }
      // toast.error(error?.response?.data?.message || "An error occurred");
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function GoogleAPIResetData({ email, reference_number, dispatch }) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };

  return async () => {
    try {
      dispatch(SetLoading(true));
      const url = `${process.env.REACT_APP_apiBaseUrl}/google-api/reset_data`;
      const response = await axios.post(
        url,
        { email, reference_number },
        reqoptions
      );

      if (response?.data?.success === false) {
        toast.error(response?.data?.message);
      } else {
        dispatch(CheckTokenExist({ email, reference_number, dispatch }));
        toast.success(response?.data?.message);
      }

      dispatch(SetLoading(false));
      return response?.data;
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        const body = { email, reference_number, dispatch };
        dispatch(ReGenerateToken(GoogleAPIResetData, body, dispatch));
        return;
      }
      toast.error(error?.response?.data?.message || "An error occurred");
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

// *************************************************************************************************

// ************************* BLOCKCHAIN SOLANA API's **************************************************

export function PostTokenId(
  { obj, commentMoreThen200, isAutoMinting, postMultipledetails },
  callBack
) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return async (dispatch) => {
    try {
      dispatch(SetLoading(true));
      dispatch(globalSlice?.actions?.SetInsiteLoading(true));
      let url = `${process.env.REACT_APP_apiBaseUrl}/api/v1/addBlockchainTokenId`;
      const response = await axios.post(url, obj, reqoptions);
      if (response?.data?.success) {
        dispatch(GetTokenId({ obj }, callBack));
        dispatch(SetLoading(false));
        const FunCallBack = (token_id) => {
          if (
            commentMoreThen200 &&
            commentMoreThen200.length &&
            isAutoMinting
          ) {
            const postdetails = commentMoreThen200.map((item) => ({
              ...item,
              userTokenID: token_id,
            }));
            dispatch(AddPost({ postdetails, dispatch }));
          }
          if (postMultipledetails && isAutoMinting) {
            dispatch(
              AddMultiplePost({
                postMultipledetails: {
                  ...postMultipledetails,
                  userTokenID: token_id,
                },
                dispatch,
              })
            );
          }
          callBack(token_id);
        };
        dispatch(PostTokenId({ obj }, FunCallBack));
        return response?.data;
      }
    } catch (error) {
      dispatch(globalSlice?.actions?.SetInsiteLoading(false));
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        let body = { obj, dispatch };
        dispatch(ReGenerateToken(PostTokenId, body, dispatch));
        return;
      }

      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function GetTokenId({ obj }, callBack) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return async (dispatch) => {
    try {
      SetLoading(true);
      let url = `${process.env.REACT_APP_apiBaseUrl}/api/v1/getBlockchainTokenId?reference_number=${obj?.reference_number}&email=${obj?.email}`;
      const response = await axios.get(url, reqoptions);
      if (response?.data?.success === true) {
        dispatch(SetLoading(false));
        if (callBack) {
          callBack(response?.data?.data?.token_id);
        }

        dispatch(
          globalSlice?.actions?.HandleHashedTokenId(
            response.data.data.hashed_token_id
          )
        );
        dispatch(
          globalSlice?.actions?.HandleTokenIdGenerate(
            response?.data?.data.token_id
          )
        );
        return response?.data;
      }
    } catch (error) {
      SetLoading(false);
      if (callBack) {
        callBack(null);
      }
      if (error?.response?.status === 401) {
        let body = { obj, dispatch };
        dispatch(ReGenerateToken(GetTokenId, body, dispatch));
        return;
      }
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function GetUserWalletDetails({ obj }) {
  const user_id = obj?.user_id;

  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return async (dispatch) => {
    try {
      SetLoading(true);
      let url = `${process.env.REACT_APP_apiBaseUrl}/blockchain/api/v1/getUserWalletDetails?user_id=${obj?.user_id}`;
      const response = await axios.get(url, reqoptions);

      if (response?.data?.success === true) {
        dispatch(SetLoading(false));
        // let userBal={
        //   walletAddress:obj?.walletAddress
        // }
        // dispatch( GetUserWalletBalance({obj}))
        dispatch(GetTokenId({ obj, dispatch }));
        dispatch(
          globalSlice?.actions?.HandleWalletDetails(
            response?.data?.data?.walletAddress
          )
        );
        dispatch(
          globalSlice?.actions?.HandleUserPrivatekeyDetails(
            response?.data?.data?.privateKey
          )
        );

        return response?.data;
      }
    } catch (error) {
      SetLoading(false);
      if (error?.response?.status === 401) {
        let body = { obj, dispatch };
        dispatch(ReGenerateToken(GetUserWalletDetails, body, dispatch));
        return;
      }

      if (error?.response?.data?.message === "User wallet details not found") {
        dispatch(UserWalletDetails({ user_id, dispatch, obj }));
      }
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

////////////////////SOLANA ENDPOINTS???????????????????

export function GenerateWalletDEtail() {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return async (dispatch) => {
    try {
      dispatch(SetLoading(true));
      let url = `${process.env.REACT_APP_apiBaseUrlSolana}/solana/api/wallet`;
      const response = await axios.get(url, reqoptions);

      if (response?.data?.success === true) {
        dispatch(SetLoading(false));

        dispatch(
          globalSlice?.actions?.GetUserSolanaDetail(response?.data?.data)
        );

        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        let body = { dispatch };
        dispatch(ReGenerateToken(GenerateWalletDEtail, body, dispatch));
        return;
      }
    } finally {
      dispatch(SetLoading(false));
    }
  };
}
export function GenerateWalletDEtailBalance() {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return async (dispatch) => {
    try {
      dispatch(SetLoading(true));
      let url = `${process.env.REACT_APP_apiBaseUrlSolana}/solana/api/balance`;
      const response = await axios.get(url, reqoptions);

      if (response?.data?.success === true) {
        dispatch(SetLoading(false));

        dispatch(
          globalSlice?.actions?.GetUserSolanaDetailBalance(response?.data?.data)
        );

        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        let body = { dispatch };
        dispatch(ReGenerateToken(GenerateWalletDEtailBalance, body, dispatch));
        return;
      }
    } finally {
      dispatch(SetLoading(false));
    }
  };
}
export function DepositBalance({ bodydata }) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return async (dispatch) => {
    try {
      dispatch(SetLoading(true));
      let url = `${process.env.REACT_APP_apiBaseUrlSolana}/solana/api/transaction`;
      const response = await axios.post(url, bodydata, reqoptions);

      if (response?.data?.success === true) {
        dispatch(SetLoading(false));

        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        let body = { dispatch, bodydata };
        dispatch(ReGenerateToken(DepositBalance, body, dispatch));
        return;
      }
    } finally {
      dispatch(SetLoading(false));
    }
  };
}
export function SolanaTransactionHistory({
  signature,
  isForSPL,
  limit = 10,
  searchText,
}) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  // const url =
  //   signature && !isForSPL
  //     ? `https://7d09018b53e3.ngrok-free.app/solana/api/transaction?beforeSignature=${signature}&limit=${limit}&isForSPL=${isForSPL}`
  //     : signature && isForSPL && !searchText
  //     ? `https://7d09018b53e3.ngrok-free.app/solana/api/transaction?beforeSignature=${signature}&limit=${limit}&isForSPL=${isForSPL}`
  //     : searchText && isForSPL && !signature
  //     ? `https://7d09018b53e3.ngrok-free.app/solana/api/transaction?limit=${limit}&isForSPL=${isForSPL}&searchText=${searchText}`
  //     : searchText && isForSPL && signature
  //     ? `https://7d09018b53e3.ngrok-free.app/solana/api/transaction?beforeSignature=${signature}&limit=${limit}&isForSPL=${isForSPL}&searchText=${searchText}`
  //     : `https://7d09018b53e3.ngrok-free.app/solana/api/transaction?limit=${limit}&isForSPL=${isForSPL}`;

  const baseUrl = `${process.env.REACT_APP_apiBaseUrlSolana}/solana/api/transaction`;

  const url =
    searchText && isForSPL && signature
      ? `${baseUrl}?beforeSignature=${signature}&limit=${limit}&isForSPL=${isForSPL}&searchText=${searchText}`
      : searchText && isForSPL && !signature
      ? `${baseUrl}?limit=${limit}&isForSPL=${isForSPL}&searchText=${searchText}`
      : signature && isForSPL
      ? `${baseUrl}?beforeSignature=${signature}&limit=${limit}&isForSPL=${isForSPL}`
      : signature && !isForSPL
      ? `${baseUrl}?beforeSignature=${signature}&limit=${limit}&isForSPL=${isForSPL}`
      : `${baseUrl}?limit=${limit}&isForSPL=${isForSPL}`;

  return async (dispatch) => {
    try {
      // dispatch(SetLoading(true));
      const response = await axios.get(url, reqoptions);

      if (response?.data?.success === true) {
        dispatch(SetLoading(false));
        dispatch(
          globalSlice?.actions?.SolanaTransactionHistoryData(
            response?.data?.data || response?.data?.data?.data
          )
        );
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        let body = { dispatch, signature, isForSPL, searchText };
        dispatch(ReGenerateToken(SolanaTransactionHistory, body, dispatch));
        return;
      }
    } finally {
      // dispatch(SetLoading(false));
    }
  };
}
export function EditSolanaWalletBalance({ body }) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return async (dispatch) => {
    try {
      dispatch(SetLoading(true));
      let url = `${process.env.REACT_APP_apiBaseUrlSolana}/solana/api/wallet`;
      const response = await axios.patch(url, body, reqoptions);

      if (response?.data?.success === true) {
        dispatch(SetLoading(false));

        dispatch(GenerateWalletDEtail());

        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // let body = { data,dispatch };
        dispatch(ReGenerateToken(EditSolanaWalletBalance, { body }, dispatch));
        return;
      }
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

////////////////////////////////////////////////////////////////////

export function GetUserWalletBalance({ getUserWalletDetails }) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  let objBalance = {
    walletAddress: getUserWalletDetails,
  };
  return async (dispatch) => {
    try {
      SetLoading(true);
      let url = `${process.env.REACT_APP_apiBaseUrl}/blockchain/api/v1/userWalletBalance`;
      const response = await axios.post(url, objBalance, reqoptions);

      if (response?.data?.success === true) {
        dispatch(SetLoading(false));
        dispatch(
          globalSlice?.actions?.HandleWalletBalance(response?.data?.amount)
        );

        return response?.data;
      }
    } catch (error) {
      SetLoading(false);
      if (error?.response?.status === 401) {
        let body = { getUserWalletDetails, dispatch };
        dispatch(ReGenerateToken(GetUserWalletBalance, body, dispatch));
        return;
      }

      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function AddMinting({
  formData,
  commentMoreThen200,
  isAutoMinting,
  postMultipledetails,
}) {
  const token = GetDecryptAccessTokenformat();
  const email = GetDecryptEmailformat();
  const reference_number = GetDecryptReferenceNumberformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      SetLoading(true);
      let url = `${process.env.REACT_APP_apiBaseUrl}/blockchain/api/v1/addMint`;
      const response = await axios.post(url, formData, reqoptions);

      if (response?.data?.success === true) {
        dispatch(SetLoading(false));

        const tokenId = response?.data?.data?.tokenID;

        if (!tokenId) {
          console.error("Token ID is undefined");
          return;
        }

        let obj = {
          email: email,
          reference_number: reference_number,
          token_id: `${tokenId}`,
        };

        dispatch(
          PostTokenId({
            obj,
            commentMoreThen200,
            isAutoMinting,
            postMultipledetails,
            dispatch,
          })
        );

        return response?.data;
      }
    } catch (error) {
      SetLoading(false);
      if (error?.response?.status === 401) {
        let body = { formData, dispatch };
        dispatch(ReGenerateToken(AddMinting, body, dispatch));
        return;
      }

      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function AddPost({ postdetails, callBack }) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      SetLoading(true);
      let url = `${process.env.REACT_APP_apiBaseUrl}/blockchain/api/v1/addPost`;
      for (const [index, item] of postdetails.entries()) {
        const response = await axios.post(url, item, reqoptions);

        if (response?.data?.success === true) {
          const mintUrl = `${process.env.REACT_APP_apiBaseUrl}/instagram/api/v1/messaging/mint-image`;
          const body = {
            media_item_id: item?.id,
            is_minted: "1",
          };
          await axios.post(mintUrl, body, reqoptions);
          if (callBack) {
            callBack(response?.data);
          }
        }

        if (index === postdetails.length - 1) {
          dispatch(SetLoading(false));
        }
      }
    } catch (error) {
      if (callBack) {
        callBack(null);
      }
      SetLoading(false);
      if (error?.response?.status === 401) {
        let body = { postdetails, dispatch };
        dispatch(ReGenerateToken(AddPost, body, dispatch));
        return;
      }

      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function AddMultiplePost({ postMultipledetails }) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      SetLoading(true);
      let url = `${process.env.REACT_APP_apiBaseUrl}/blockchain/api/v1/multiplePost`;
      const response = await axios.post(url, postMultipledetails, reqoptions);
      if (response?.data?.success === true) {
        dispatch(SetLoading(false));

        const mintMultipleurl = `${process.env.REACT_APP_apiBaseUrl}/instagram/api/v1/messaging/mint-multiple`;
        const body = {
          media_item_id:
            postMultipledetails?.id || postMultipledetails?.media_item_id,
          is_already_mint_for_multiple:
            postMultipledetails?.is_already_mint_for_multiple,
        };
        await axios.post(mintMultipleurl, body, reqoptions);

        return response?.data;
      }
    } catch (error) {
      SetLoading(false);
      if (error?.response?.status === 401) {
        let body = { postMultipledetails, dispatch };
        dispatch(ReGenerateToken(AddMultiplePost, body, dispatch));
        return;
      }

      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function GetTransactionHistory({ address }) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      dispatch(SetLoading(true));
      let url = `${process.env.REACT_APP_apiBaseUrl}/blockchain/api/v1/getUserWalletCompleteDetails?walletAddress=${address} `;
      const response = await axios.get(url, reqoptions);

      if (response?.data?.success === true) {
        dispatch(
          globalSlice?.actions?.HandleTransactionHistory(
            response?.data?.data?.walletDetails
          )
        );
        dispatch(SetLoading(false));
        return response?.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        let body = { dispatch };
        dispatch(ReGenerateToken(GetTransactionHistory, body, dispatch));
        return;
      }

      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function UserWalletDetails({ user_id, obj }) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return async (dispatch) => {
    try {
      dispatch(SetLoading(true));
      let url = `${process.env.REACT_APP_apiBaseUrl}/blockchain/api/v1/userWalletDetail`;
      let objdata = {
        user_id: user_id,
      };
      const response = await axios.post(url, objdata, reqoptions);
      if (response?.data) {
        dispatch(SetLoading(false));
        dispatch(GetUserWalletDetails({ obj, dispatch }));
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        const body = { user_id, obj, dispatch };
        dispatch(ReGenerateToken(UserWalletDetails, body, dispatch));
        return;
      }
      toast.error(error?.response?.data?.message);
      dispatch(SetLoading(false));
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

// *********************************************************************************************
/////////////////////Billing////////////////////////////////////////////
export function OpenAIandGeminiUserDataSave({ obj, dispatch }) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return async () => {
    try {
      // dispatch(SetLoading(true));
      let url = `${process.env.REACT_APP_apiBaseUrlSolana}/billingStats/api/v1/saveUserOpenAiGeminiUsageCost`;
      const response = await axios.post(url, obj, reqoptions);
      if (response?.data?.success === true) {
        // dispatch(SetLoading(false));
        toast.success(response?.data?.data?.message);
        return response?.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        let body = { obj, dispatch };
        dispatch(ReGenerateToken(OpenAIandGeminiUserDataSave, body, dispatch));
        return;
      }
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function GetMqMessage({ email, referenceNumber }) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      dispatch(SetLoading(true));
      const url = `${process.env.REACT_APP_apiBaseUrl}/api/v1/getMqMessage?email=${email}&reference_number=${referenceNumber}`;
      const response = await axios.get(url, reqoptions);

      if (response?.data?.success) {
        dispatch(SetLoading(false));
        toast.success(response.data.message);
        return response.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        const body = { email, referenceNumber, dispatch };
        dispatch(ReGenerateToken(GetMqMessage, body, dispatch));
        return;
      }
      toast.error(error?.response?.data?.message || "An error occurred");
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function GetFaqAPI({ dispatch }) {
  const token = localStorage?.getItem("access_token");

  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async () => {
    try {
      dispatch(SetLoading(true));
      let url = `${process.env.REACT_APP_apiBaseUrlSolana}/admin/api/v1/getAllFaq`;
      const response = await axios.get(url, reqoptions);
      if (response?.data) {
        dispatch(SetLoading(false));
        dispatch(globalSlice?.actions?.HandleAllFaq(response?.data));
        return response?.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        let body = { dispatch };
        dispatch(ReGenerateToken(GetFaqAPI, body, dispatch));
        return;
      }

      // toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function GenerateQrCode({ dispatch }) {
  const token = localStorage?.getItem("access_token");

  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async () => {
    try {
      dispatch(SetLoading(true));
      let url = `${process.env.REACT_APP_apiBaseUrlSolana}/admin/api/v1/generateCode`;
      const response = await axios.post(url, {}, reqoptions);
      if (response?.data) {
        dispatch(SetLoading(false));
        dispatch(globalSlice?.actions?.HandleQrCode(response?.data));
        return response?.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        let body = { dispatch };
        dispatch(ReGenerateToken(GenerateQrCode, body, dispatch));
        return;
      }

      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function GetQrCode({ dispatch, uniqueId }) {
  const token = localStorage?.getItem("access_token");

  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async () => {
    try {
      dispatch(SetLoading(true));
      let url = `${process.env.REACT_APP_apiBaseUrlSolana}/admin/api/v1/getUserLoginData/${uniqueId}`;
      const response = await axios.get(url, reqoptions);
      if (response?.data) {
        dispatch(SetLoading(false));
        dispatch(
          globalSlice?.actions?.GetHandleQrCode(
            response?.data?.data ? response?.data?.data : response?.data
          )
        );
        return response?.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        let body = { dispatch, uniqueId };
        dispatch(ReGenerateToken(GetQrCode, body, dispatch));
        return;
      }

      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function VerifyQrcode({ dispatch, obj }) {
  const token = localStorage?.getItem("access_token");

  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async () => {
    try {
      dispatch(SetLoading(true));
      let url = `${process.env.REACT_APP_apiBaseUrlSolana}/admin/api/v1/verifyQrcode`;
      const response = await axios.post(url, obj, reqoptions);
      if (response?.data) {
        dispatch(SetLoading(false));
        // dispatch(globalSlice?.actions?.HandleQrCode(response?.data));
        return response?.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        let body = { dispatch, obj };
        dispatch(ReGenerateToken(VerifyQrcode, body, dispatch));
        return;
      }

      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function GetQrCodeByUniqueId({ dispatch, obj }) {
  const token = localStorage?.getItem("access_token");

  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async () => {
    try {
      dispatch(SetLoading(true));
      let url = `${process.env.REACT_APP_apiBaseUrlSolana}/admin/api/v1/getQrDataByUniqeId`;
      const response = await axios.post(url, obj, reqoptions);
      if (response?.data) {
        dispatch(SetLoading(false));
        dispatch(globalSlice?.actions?.GetHandleQrCodeUniqueId(response));
        return response?.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        let body = { dispatch, obj };
        dispatch(ReGenerateToken(GetQrCodeByUniqueId, body, dispatch));
        return;
      }

      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

// ************************************************************************************************

// ***********************************************TIKTOK AUTHENTICATION***********************************

export const TikTokLoginHandler = ({ userData }) => {
  const token = GetDecryptAccessTokenformat();

  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      dispatch(SetLoading(true));
      let url = `${process.env.REACT_APP_apiBaseUrl}/api/v1/auth/tiktok`;
      const response = await axios.post(url, userData, reqoptions);

      if (response) {
        window.location.href = response?.data?.data;
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        let body = { userData, dispatch };
        dispatch(ReGenerateToken(TikTokLoginHandler, body, dispatch));
        return;
      }
      toast.error(error.response?.data?.message || "An error occurred");
    } finally {
      dispatch(SetLoading(false));
    }
  };
};

export const TikTokAuthCallback = ({ obj, navigate }) => {
  const token = GetDecryptAccessTokenformat();

  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      dispatch(SetLoading(true));
      const url = `${process.env.REACT_APP_apiBaseUrl}/api/v1/auth/tiktok/callback`;

      const response = await axios.post(url, obj, reqoptions);

      if (response) {
        toast.success(response?.data?.message || "Error occurred");
        navigate("/tiktokuserprofile");
        return response.data;
      } else {
        toast.error(response?.data?.message || "Error occurred");
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        let body = { dispatch, obj, navigate };
        dispatch(ReGenerateToken(TikTokAuthCallback, body, dispatch));
        return;
      }

      toast.error(error.response?.data?.message || "An error occurred");
    } finally {
      dispatch(SetLoading(false));
    }
  };
};

export function GetTiktokProfileData({ dispatch, userData }) {
  const token = GetDecryptAccessTokenformat();

  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async () => {
    try {
      dispatch(SetLoading(true));
      let url = `${process.env.REACT_APP_apiBaseUrl}/api/v1/tiktokUserProfile?email=${userData?.email}&reference_number=${userData?.reference_number}`;
      const response = await axios.get(url, reqoptions);
      if (response?.data) {
        dispatch(SetLoading(false));
        dispatch(globalSlice?.actions?.GetTiktokUserData(response?.data?.data));
        return response?.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        let body = { dispatch, userData };
        dispatch(ReGenerateToken(GetTiktokProfileData, body, dispatch));
        return;
      }

      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function GetTiktokMediaRecord({ dispatch, userData }) {
  const token = GetDecryptAccessTokenformat();

  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async () => {
    try {
      dispatch(SetLoading(true));
      let url = `${process.env.REACT_APP_apiBaseUrl}/api/v1/tiktokMediaRecord?email=${userData?.email}&reference_number=${userData?.reference_number}`;
      const response = await axios.get(url, reqoptions);
      if (response?.data) {
        dispatch(SetLoading(false));
        dispatch(globalSlice?.actions?.TiktokMediaRecord(response?.data?.data));
        return response?.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        let body = { dispatch, userData };
        dispatch(ReGenerateToken(GetTiktokMediaRecord, body, dispatch));
        return;
      }

      // toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function PosttiktokMedia({ obj, dispatch, userData }) {
  const token = GetDecryptAccessTokenformat();
  return async () => {
    const reqoptions = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    };

    try {
      dispatch(SetLoading(true));
      let url = `${process.env.REACT_APP_apiBaseUrl}/tiktok/api/v1/messaging/postPhotos`;

      let form_data = new FormData();
      form_data.append("images", obj?.images);
      form_data.append("reference_number", obj?.reference_number);
      form_data.append("email", obj?.email);
      form_data.append("title", obj?.title);
      form_data.append("description", obj?.description);

      const response = await axios.post(url, form_data, reqoptions);

      if (response?.data?.success === true) {
        dispatch(SetLoading(false));
        dispatch(GetTiktokMediaRecord({ obj, dispatch, userData }));
        toast.success(response?.data?.message);

        return response?.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        let body = {
          obj,
          dispatch,
          userData,
        };
        dispatch(ReGenerateToken(PosttiktokMedia, body, dispatch));
        return;
      }
      toast.error(error.response?.data?.message || "An error occurred");
    } finally {
      dispatch(SetLoading(false));
    }
  };
}
export function TokenExistTikTok({ dispatch, userData }) {
  const token = GetDecryptAccessTokenformat();

  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async () => {
    try {
      dispatch(SetLoading(true));
      let url = `${process.env.REACT_APP_apiBaseUrl}/api/v1/tiktokTokenExist`;
      const response = await axios.post(url, userData, reqoptions);
      if (response?.data) {
        dispatch(SetLoading(false));
        dispatch(
          globalSlice?.actions?.GetTiktokToken(response?.data?.token_exist)
        );
        return response?.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      dispatch(globalSlice?.actions?.GetTiktokToken(""));
      if (error?.response?.status === 401) {
        let body = { dispatch, userData };
        dispatch(ReGenerateToken(TokenExistTikTok, body, dispatch));
        return;
      }
    } finally {
      dispatch(SetLoading(false));
    }
  };
}
export function RevokeTikTokAccess({ dispatch, userData }) {
  const token = GetDecryptAccessTokenformat();

  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async () => {
    try {
      dispatch(SetLoading(true));
      let url = `${process.env.REACT_APP_apiBaseUrl}/api/v1/revoke/tiktok`;
      const response = await axios.post(url, userData, reqoptions);

      if (response?.data) {
        dispatch(SetLoading(false));
        dispatch(TokenExistTikTok({ dispatch, userData }));
        toast.success(response?.data?.message);

        return response?.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));

      if (error?.response?.status === 401) {
        let body = { dispatch, userData };
        dispatch(ReGenerateToken(RevokeTikTokAccess, body, dispatch));
        return;
      }

      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

// ******************************************************************************************************
////////////////////////////////Ai/////////////////////////////////////////
export function GetUserChatHistory({ dispatch, email, type, setUserChat }) {
  const token = GetDecryptAccessTokenformat();

  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async () => {
    try {
      // dispatch(SetLoading(true));
      const url = `${
        process.env.REACT_APP_apiBaseUrlAI
      }/ai/api/history_sync?user_email=${email}&type=${type || "text"}`;
      const response = await axios.get(url, reqoptions);

      if (response?.data) {
        // dispatch(SetLoading(false));
        dispatch(globalSlice?.actions?.HandleStoreUserHistory(response?.data));
        return response?.data;
      }
    } catch (error) {
      if (
        error?.response?.data?.error ===
        "No data found for the provided filters."
      ) {
        if (typeof setUserChat === "function") {
          setUserChat([]);
        }
      }

      console.error("Error", error);
      dispatch(SetLoading(false));

      if (error?.response?.status === 401) {
        const body = { dispatch, email, type, setUserChat };
        dispatch(ReGenerateToken(GetUserChatHistory, body, dispatch));
        return;
      }

      // toast.error(error?.response?.data?.message || 'An error occurred.');
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function DeleteUserChatHistory({
  dispatch,
  id,
  email,
  type,
  setUserChat,
}) {
  const token = GetDecryptAccessTokenformat();
  // const email = GetDecryptEmailformat();
  // const reference_number = GetDecryptReferenceNumberformat();

  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data", // Set appropriate Content-Type for FormData
    },
  };

  return async () => {
    try {
      dispatch(SetLoading(true));

      const formData = new FormData();
      formData.append("id", id);
      formData.append("user_email", email);

      const url = `${process.env.REACT_APP_apiBaseUrlAI}/ai/api/delete_history`;
      const response = await axios.delete(url, {
        ...reqoptions,
        data: formData,
      });

      if (response?.data) {
        dispatch(SetLoading(false));
        toast.success(response?.data?.Status);
        dispatch(GetUserChatHistory({ dispatch, email, type, setUserChat }));
        return response?.data;
      }
    } catch (error) {
      console.error("Error", error);
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        const body = { dispatch, id, email, type, setUserChat };
        dispatch(ReGenerateToken(DeleteUserChatHistory, body, dispatch));
        return;
      }

      // Optional: Toast notification for error
      // toast.error(error?.response?.data?.message || 'An error occurred.');
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

// ************************************SUBSCRIPTION**************************************

export function GetSubscriptionPlans({ email, reference_number }) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      dispatch(SetLoading(true));
      const url = `${process.env.REACT_APP_apiBaseUrl}/api/v1/getSubscriptionPlanList?email=${email}&reference_number=${reference_number}`;
      const response = await axios.get(url, reqoptions);

      if (response?.data?.success) {
        dispatch(SetLoading(false));
        dispatch(
          globalSlice?.actions?.HandleSubscriptionPlans(response.data.data)
        );
        return response.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        const body = { email, reference_number, dispatch };
        dispatch(ReGenerateToken(GetSubscriptionPlans, body, dispatch));
        return;
      }
      toast.error(error?.response?.data?.message || "An error occurred");
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function GetSubscriptionPlan({
  email,
  reference_number,
  tier_reference_number,
  payment_plan,
}) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };

  return async (dispatch) => {
    try {
      dispatch(SetLoading(true));
      const url = `${process.env.REACT_APP_apiBaseUrl}/api/v1/getSubscriptionPlan`;
      const response = await axios.post(
        url,
        {
          email,
          reference_number,
          tier_reference_number,
          payment_plan,
        },
        reqoptions
      );

      if (response?.data?.success) {
        dispatch(SetLoading(false));
        // dispatch(globalSlice?.actions?.HandleSubscriptionPlans(response.data.data));
        toast.success(response.data.message);
        return response.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        let body = {
          email,
          reference_number,
          tier_reference_number,
          payment_plan,
        };
        dispatch(ReGenerateToken(GetSubscriptionPlan, body, dispatch));
        return;
      }
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function GetActivePlan({ email, referenceNumber }) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      dispatch(SetLoading(true));
      const url = `${process.env.REACT_APP_apiBaseUrl}/api/v1/getWalletDetails?email=${email}&reference_number=${referenceNumber}`;
      const response = await axios.get(url, reqoptions);

      if (response?.data?.success) {
        dispatch(SetLoading(false));
        dispatch(
          globalSlice?.actions?.HandleActivePlan(response?.data?.data?.[0])
        );
        toast.success(response.data.message);
        return response.data.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        const body = { email, referenceNumber, dispatch };
        dispatch(ReGenerateToken(GetActivePlan, body, dispatch));
        return;
      }
      toast.error(error?.response?.data?.message || "An error occurred");
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

// *********************************************************************************************

// ***************************************************NFT********************************************

export function MintCNFT({ obj, CollectionBoolean }) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };

  return async (dispatch) => {
    try {
      dispatch(SetLoading(true));
      const url = `${process.env.REACT_APP_apiBaseUrlSolana}/solana/api/mint-nft`;
      const response = await axios.post(url, obj, reqoptions);

      if (response?.data?.success) {
        dispatch(SetLoading(false));
        dispatch(GetNftMinted({ CollectionBoolean }));
        dispatch(GenerateWalletDEtailBalance());

        toast.success(response.data.message);
        return response.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        let body = { obj };
        dispatch(ReGenerateToken(MintCNFT, body, dispatch));
        return;
      }
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function GetNftMinted({ CollectionBoolean, page = 1, limit = 6 }) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch, getState) => {
    try {
      dispatch(SetLoading(true));
      const url = `${process.env.REACT_APP_apiBaseUrlSolana}/solana/api/nft-owned?&page=${page}&limit=${limit}`;
      const response = await axios.get(url, reqoptions);

      if (response?.data?.success) {
        dispatch(SetLoading(false));
        const currentState = getState();
        const existingData = currentState.counter.MintedNft || [];

        const newData =
          page === 1
            ? response?.data?.data.items
            : [...existingData, ...response?.data?.data.items];

        dispatch(globalSlice?.actions?.HandleNFTMInted(newData));

        if (response?.data?.data?.length > 0 && page === 1) {
          toast.success(response.data.message);
        }
        dispatch(GenerateWalletDEtailBalance());
        return {
          data: response.data.data,
          hasMore: response.data.data.length >= limit,
        };
      } else {
        dispatch(SetLoading(false));
        toast.error(response.data.message);
        return { data: [], hasMore: false };
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        dispatch(
          ReGenerateToken(
            GetNftMinted,
            { CollectionBoolean, page, limit },
            dispatch
          )
        );
        return { data: [], hasMore: true };
      }
      toast.error(error?.response?.data?.message || "An error occurred");
      return { data: [], hasMore: false };
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function MintNFTCollection({ objData, CollectionBoolean }) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };

  return async (dispatch) => {
    try {
      // dispatch(SetLoading(true));
      const url = `${process.env.REACT_APP_apiBaseUrlSolana}/solana/api/mint-nft-collection`;
      toast.warning("Minting Process take sometime");

      const response = await axios.post(url, objData, reqoptions);

      if (response?.data?.success) {
        dispatch(SetLoading(false));
        dispatch(GetNftMinted({ CollectionBoolean }));
        dispatch(GenerateWalletDEtailBalance());

        toast.success(response.data.message);
        return response.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        let body = { objData };
        dispatch(ReGenerateToken(MintNFTCollection, body, dispatch));
        return;
      }
      if (error?.response?.status === 504) {
        dispatch(GetNftMinted());
      }
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function TransferMintNFT({ obj, CollectionBoolean }) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };

  return async (dispatch) => {
    try {
      dispatch(SetLoading(true));
      const url = `${process.env.REACT_APP_apiBaseUrlSolana}/solana/api/transfer`;
      const response = await axios.post(url, obj, reqoptions);

      if (response?.data?.success) {
        dispatch(SetLoading(false));
        dispatch(GetNftMinted({ CollectionBoolean }));
        dispatch(GenerateWalletDEtailBalance());

        toast.success(response.data.message);
        return response.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        let body = { obj, CollectionBoolean };
        dispatch(ReGenerateToken(TransferMintNFT, body, dispatch));
        return;
      }
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function UploadToBucketCollection({ obj, setCOllection }) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  };

  return async (dispatch) => {
    try {
      let form_data = new FormData();
      dispatch(SetLoading(true));

      // Correctly appending multiple images
      obj.forEach((ele) => {
        form_data.append("image", ele); // Ensure 'ele.file' contains a File object
      });

      let url = `${process.env.REACT_APP_apiBaseUrlSolana}/solana/api/upload/image`;

      if (form_data) {
        const response = await axios.post(url, form_data, reqoptions);

        if (response?.data?.success === true) {
          dispatch(
            globalSlice?.actions?.GetMultipleNftMinted(response?.data?.data)
          );
          dispatch(SetLoading(false));
          dispatch(setCOllection([]));
          return response?.data;
        }
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        const body = { obj, dispatch };
        dispatch(ReGenerateToken(UploadToBucketCollection, body, dispatch));
        return;
      }
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function GetTransactionDetails({ signature }) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      dispatch(SetLoading(true));
      const url = `${process.env.REACT_APP_apiBaseUrlSolana}/solana/api/transaction/${signature}`;
      const response = await axios.get(url, reqoptions);

      if (response?.data?.success) {
        dispatch(SetLoading(false));
        dispatch(
          globalSlice.actions.HandleTransactionDetails(response.data.data)
        );
        return response.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        const body = { signature, dispatch };
        dispatch(ReGenerateToken(GetTransactionDetails, body, dispatch));
        return;
      }
      toast.error(error?.response?.data?.message || "An error occurred");
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function GetNftCollectionAssets({
  page = 1,
  limit = 100,
  collectionMint,
}) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      dispatch(SetLoading(true));
      const url = `${process.env.REACT_APP_apiBaseUrlSolana}/solana/api/nft-collection/assets?page=${page}&limit=${limit}&collectionMint=${collectionMint}`;
      const response = await axios.get(url, reqoptions);

      if (response?.data?.success) {
        dispatch(SetLoading(false));
        dispatch(
          globalSlice?.actions?.HandleNftCollectionAssets(response.data.data)
        );
        return response.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        const body = { page, limit, collectionMint };
        dispatch(ReGenerateToken(GetNftCollectionAssets, body, dispatch));
        return;
      }
      toast.error(error?.response?.data?.message || "An error occurred");
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

// ************************************************************************************************

// ***************************************GEMINI*********************************************************

export function GetCHatsessionHistory({
  finalsessionId,
  getchatID,
  addchatsessionId,
  navigate,
}) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      const url = `${
        process.env.REACT_APP_apiBaseUrlAI
      }/ai/api/chatsession_history?session_id=${
        finalsessionId || getchatID || ""
      }`;
      const response = await axios.get(url, reqoptions);

      if (response?.data) {
        if (addchatsessionId) {
          navigate(`/gemini?chatid=${getchatID}`);
        }
        dispatch(globalSlice?.actions?.HandleGeminiData(response?.data));
        return response.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        const body = { finalsessionId, getchatID, addchatsessionId, navigate };
        dispatch(ReGenerateToken(GetCHatsessionHistory, body, dispatch));
        return;
      }
      toast.error(error?.response?.data?.message || "An error occurred");
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function OneFeedAPI({
  obj,
  callback,
  onError,
  navigate,
  setFileupload,
  setFileList,
}) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      const url = `${process.env.REACT_APP_apiBaseUrlAI}/ai/api/onefeed_new`;

      let form_data = new FormData();

      form_data.append("chat_session_id", obj?.chat_session_id || "");
      form_data.append(
        "user_reference_number",
        obj?.user_reference_number || ""
      );
      form_data.append("user_email", obj?.user_email || "");
      form_data.append("text", obj?.text || "");
      form_data.append("user_image", obj?.user_image || "");
      form_data.append("user_image_url", obj?.user_image_url || "");
      form_data.append("audio", obj?.audio || "");

      const response = await axios.post(url, form_data, reqoptions);

      if (response?.data) {
        setFileupload(null || "" || []);
        setFileList(null || "" || []);
        const sessionId = response?.data?.chat_session_id;
        if (sessionId) {
          navigate(`/gemini?chatid=${response?.data?.chat_session_id}`);
          // sessionStorage.setItem("chat_session_id", sessionId);
        }

        if (callback && typeof callback === "function") {
          callback(response?.data, dispatch); // pass data and dispatch
        }

        return response.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        let body = { obj, callback, onError, navigate };
        dispatch(ReGenerateToken(OneFeedAPI, body, dispatch));
        return;
      }
      if (onError && typeof onError === "function") {
        onError(error);
      }

      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

// export function OneFeedAPI({ obj, callback, onError, navigate }) {
//   const token = GetDecryptAccessTokenformat();

//   // Don't set Content-Type manually when using FormData
//   const reqoptions = {
//     headers: {
//       Authorization: `Bearer ${token}`,
//       // Let axios set the correct Content-Type with boundary
//     },
//   };

//   return async (dispatch) => {
//     try {
//       const url = `${process.env.REACT_APP_apiBaseUrl}/ai/api/onefeed_new`;

//       const form_data = new FormData();

//       form_data.append("chat_session_id", obj?.chat_session_id || "");
//       form_data.append("user_reference_number", obj?.user_reference_number || "");
//       form_data.append("user_email", obj?.user_email || "");
//       form_data.append("text", obj?.text || "");

//       // Ensure file fields are File or Blob instances
//       if (obj?.user_image instanceof File) {
//         form_data.append("user_image", obj.user_image);
//       }

//       form_data.append("user_image_url", obj?.user_image_url || "");

//       if (obj?.audio instanceof File) {
//         form_data.append("audio", obj.audio);
//       }

//       const response = await axios.post(url, form_data, reqoptions);

//       if (response?.data) {
//         const sessionId = response?.data?.chat_session_id;

//         if (sessionId) {
//           navigate(`/gemini?chatid=${sessionId}`);
//         }

//         if (callback && typeof callback === "function") {
//           callback(response?.data, dispatch);
//         }

//         return response.data;
//       } else {
//         dispatch(SetLoading(false));
//         toast.error(response.data?.message || "Unexpected response");
//       }
//     } catch (error) {
//       dispatch(SetLoading(false));

//       if (error?.response?.status === 401) {
//         const body = { obj, callback, onError, navigate };
//         dispatch(ReGenerateToken(OneFeedAPI, body, dispatch));
//         return;
//       }

//       if (onError && typeof onError === "function") {
//         onError(error);
//       }

//       toast.error(error?.response?.data?.message || "An error occurred");
//     } finally {
//       dispatch(SetLoading(false));
//     }
//   };
// }

export function GetUserSessionID({ email }) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      const url = `${process.env.REACT_APP_apiBaseUrlAI}/ai/api/sessionstitle_api?user_email=${email}`;
      const response = await axios.get(url, reqoptions);

      if (response?.data) {
        dispatch(globalSlice?.actions?.HandleUserChatSessionID(response?.data));
        return response.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        const body = { email };
        dispatch(ReGenerateToken(GetUserSessionID, body, dispatch));
        return;
      }
    } finally {
      dispatch(SetLoading(false));
    }
  };
}
export function GetUserSearchTopic({ email, searchTopic, date: dateString }) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      const url = dateString
        ? `${process.env.REACT_APP_apiBaseUrlAI}/ai/api/search_topics?user_email=${email}&date=${dateString}`
        : `${process.env.REACT_APP_apiBaseUrlAI}/ai/api/search_topics?user_email=${email}&topic=${searchTopic}`;
      const response = await axios.get(url, reqoptions);

      if (response?.data) {
        dispatch(
          globalSlice?.actions?.HandleSeachGeminiDatabyTopic(response?.data)
        );
        return response.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        const body = { email, searchTopic, date: dateString };
        dispatch(ReGenerateToken(GetUserSearchTopic, body, dispatch));
        return;
      }
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function DeleteCHatsessionHistory({
  chatSessionId,
  callback,
  navigate,
}) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      const url = `${process.env.REACT_APP_apiBaseUrlAI}/ai/api/deletechat_session?session_id=${chatSessionId}`;
      const response = await axios.delete(url, reqoptions);

      if (response?.data) {
        if (callback) {
          callback(response.data, dispatch);
        }

        toast.success(response.data.message);
        return response.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        const body = { chatSessionId, callback };
        dispatch(ReGenerateToken(GetCHatsessionHistory, body, dispatch));
        return;
      }
      toast.error(error?.response?.data?.message || "An error occurred");
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function GetPromptSuggestion() {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };

  return async (dispatch) => {
    try {
      const url = `${process.env.REACT_APP_apiBaseUrlAI}/ai/api/prompt_suggestions`;
//       const url = `
// https://willetta-undefendable-glynis.ngrok-free.dev/ai/api/prompt_suggestions`;
      const response = await axios.get(url, reqoptions);

      if (response?.data) {
        dispatch(
          globalSlice?.actions?.HandleGeminiDataPromptSuggestion(
            response?.data?.suggestions
          )
        );
        return response.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        const body = {};
        dispatch(ReGenerateToken(GetPromptSuggestion, body, dispatch));
        return;
      }
      toast.error(error?.response?.data?.message || "An error occurred");
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function PostLikedChat({ obj, finalsessionId }) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };

  return async (dispatch) => {
    try {
      dispatch(SetLoading(true));
      const url = `${process.env.REACT_APP_apiBaseUrlAI}/ai/api/flag_response`;

      const response = await axios.post(url, obj, reqoptions);

      if (response?.data) {
        dispatch(SetLoading(false));
        dispatch(GetCHatsessionHistory({ finalsessionId }));

        toast.success(response.data.message);
        return response.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        let body = { obj, finalsessionId };
        dispatch(ReGenerateToken(PostLikedChat, body, dispatch));
        return;
      }
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function PromptEnhancer({ promptObj, setText }) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      dispatch(SetLoading(true));
      const url = `${process.env.REACT_APP_apiBaseUrlAI}/ai/api/prompt_enhancer`;
      const response = await axios.post(url, promptObj, reqoptions);

      if (response?.data) {
        setText(response?.data?.enhanced_prompt);
        toast.success(response.data.message);
        return response.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        const body = { promptObj, setText };
        dispatch(ReGenerateToken(PromptEnhancer, body, dispatch));
        return;
      }
      toast.error(error?.response?.data?.message || "An error occurred");
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

// *****************************************************************************************************

export function GETPRWPrice() {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      const url = `${process.env.REACT_APP_apiBaseUrlSolana}/solana/api/prw-price`;
      const response = await axios.get(url, reqoptions);

      if (response?.data) {
        dispatch(
          globalSlice?.actions?.HandlePRWPrice(response?.data?.data.prw_usd)
        );
        return response.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        const body = {};
        dispatch(ReGenerateToken(GETPRWPrice, body, dispatch));
        return;
      }
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function CheckoutSession({ obj }) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      dispatch(SetLoading(true));
      const url = `${process.env.REACT_APP_apiBaseUrl}/stripe/api/v1/create-checkout-session`;
      const response = await axios.post(url, obj, reqoptions);
      if (response) {
        sessionStorage.clear();
        // Redirect in the same tab
        window.location.href = response?.data?.data?.session_url;

        toast.success(response.data?.message);
        return response.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      toast.error(error?.response.data.message);
      if (error?.response?.status === 401) {
        const body = { obj };
        dispatch(ReGenerateToken(CheckoutSession, body, dispatch));
        return;
      }
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function PlanPayment({ obj }) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      dispatch(SetLoading(true));
      const url = `${process.env.REACT_APP_apiBaseUrl}/stripe/api/v1/${obj?.plan_type=="daily"? "create-daily-subscription-session":"create-subscription-session"}`;
      const response = await axios.post(url, obj, reqoptions);
      if (response) {
        // Redirect in the same tab
        window.location.href = response?.data?.data?.session_url;

        toast.success(response.data?.message);
        return response.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        const body = { obj };
        dispatch(ReGenerateToken(PlanPayment, body, dispatch));
        return;
      }
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function CancelPayment({ obj }) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      dispatch(SetLoading(true));
      const url = `${process.env.REACT_APP_apiBaseUrl}/stripe/api/v1/cancel-subscription`;
      const response = await axios.post(url, obj, reqoptions);
      if (response) {
        toast.success(response.data?.message);
        return response.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        const body = { obj };
        dispatch(ReGenerateToken(PlanPayment, body, dispatch));
        return;
      }
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function ListingGoogleEvents({ dispatch }) {
  const referenceNumber = GetDecryptReferenceNumberformat();
  const email = GetDecryptEmailformat();
  const token = GetDecryptAccessTokenformat();

  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const formData = new FormData();

  formData.append("email", email);
  formData.append("reference_number", referenceNumber);
  formData.append("max_results", "10");
  return async () => {
    try {
      dispatch(SetLoading(true));
      let url = `${process.env.REACT_APP_apiBaseUrl}/google-api/list_events`;
      const response = await axios.post(url, formData, reqoptions);

    

      if (response?.data?.success === true) {
        dispatch(HandleCalenderData(response?.data?.data?.events));
        return response?.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        return;
      }

      // toast.error(error?.response?.data?.message || "internal server error");
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export const DeleteCalenderEvent = ({ payload }) => {
  const token = GetDecryptAccessTokenformat();
  const referenceNumber = GetDecryptReferenceNumberformat();
  const email = GetDecryptEmailformat();

  return async (dispatch) => {
    try {
      dispatch(SetLoading(true));

      const url = `${process.env.REACT_APP_apiBaseUrl}/google-api/delete_event`;

      // x-www-form-urlencoded payload
      const formData = new URLSearchParams();

      formData.append("email", email);
      formData.append("reference_number", referenceNumber);
      formData.append("event_id", payload?.event_id);

      const response = await axios.post(url, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });

      dispatch(ListingGoogleEvents({ dispatch }));

      return response.data;
    } catch (error) {
      dispatch(SetLoading(false));

      if (error?.response?.status === 401) {
        dispatch(ReGenerateToken(DeleteCalenderEvent, { payload }, dispatch));
        return;
      }

      throw error;
    } finally {
      dispatch(SetLoading(false));
    }
  };
};

export function GetWeePointDetail() {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      const url = `${process.env.REACT_APP_apiBaseUrlSolana}/weepoints/user-weepoint-details`;
      // const url = `http://localhost:3060/user-weepoint-details`;

      const response = await axios.get(url, reqoptions);

      if (response?.data) {
        dispatch(HandleWeePointData(response?.data?.data));
        return response.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        const body = {};
        dispatch(ReGenerateToken(GetWeePointDetail, body, dispatch));
        return;
      }
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export const ColledtWeePoints = ({ payload }) => {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      const url = `${process.env.REACT_APP_apiBaseUrlSolana}/weepoints/collect-weepoints`;
      // const url = `http://localhost:3060/collect-weepoints`;

      const response = await axios.post(url, payload, reqoptions);

      if (response?.data) {
        dispatch(GetWeePointDetail());
        return response.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        const body = { payload };
        dispatch(ReGenerateToken(ColledtWeePoints, body, dispatch));
        return;
      }
      toast.error(
        error?.response?.data?.message ||
          error?.response?.message ||
          "Something went wrong"
      );
    } finally {
      dispatch(SetLoading(false));
    }
  };
};

export const TransferWeePoints = ({ payload }) => {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      const url = `${process.env.REACT_APP_apiBaseUrlSolana}/weepoints/transfer-weepoints`;
      const response = await axios.post(url, payload, reqoptions);

      if (response?.data.success === true) {
        toast.success(response?.data?.message);

        dispatch(GetWeePointDetail());

        return response.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        const body = { payload };
        dispatch(ReGenerateToken(TransferWeePoints, body, dispatch));
        return;
      }
      toast.error(
        error?.response?.data?.message ||
          error?.response?.message ||
          "Something went wrong"
      );
    } finally {
      dispatch(SetLoading(false));
    }
  };
};
export const GiftWeePoints = ({ payload }) => {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      const url = `${process.env.REACT_APP_apiBaseUrlSolana}/weepoints/gift-weepoints`;
      // const url = `http://localhost:3060/gift-weepoints`;
      const response = await axios.post(url, payload, reqoptions);

      if (response?.data.success === true) {
        toast.success(response?.data?.message);

        dispatch(GetWeePointDetail());

        return response.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        const body = { payload };
        dispatch(ReGenerateToken(GiftWeePoints, body, dispatch));
        return;
      }
      toast.error(
        error?.response?.data?.message ||
          error?.response?.message ||
          "Something went wrong"
      );
    } finally {
      dispatch(SetLoading(false));
    }
  };
};
export const GiftPRWPoints = ({ payload }) => {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      const url = `${process.env.REACT_APP_apiBaseUrlSolana}/solana/api/gift-prw-token`;
      const response = await axios.post(url, payload, reqoptions);

      if (response?.data.success === true) {
        toast.success(response?.data?.message);

        dispatch(GenerateWalletDEtailBalance());

        return response.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        const body = { payload };
        dispatch(ReGenerateToken(GiftPRWPoints, body, dispatch));
        return;
      }
      toast.error(
        error?.response?.data?.message ||
          error?.response?.message ||
          "Something went wrong"
      );
    } finally {
      dispatch(SetLoading(false));
    }
  };
};
export const CustomPRWPoints = ({ payload }) => {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      const url = `${process.env.REACT_APP_apiBaseUrlSolana}/solana/api/claim-by-amount`;
      const response = await axios.post(url, payload, reqoptions);

      if (response?.data.success === true) {
        toast.success(response?.data?.message);

        return response.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        const body = { payload };
        dispatch(ReGenerateToken(CustomPRWPoints, body, dispatch));
        return;
      }
      toast.error(
        error?.response?.data?.message ||
          error?.response?.message ||
          "Something went wrong"
      );
    } finally {
      dispatch(SetLoading(false));
    }
  };
};
//////////////////// GET POOL PRIZE
export const GetPoolDataPrize = () => {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      const url = `${process.env.REACT_APP_apiBaseUrlSolana}/solana/api/token/getPoolDataWithPrice/EdAfL6zjqWAuHzr9PH3imkAKMrSVjccDy8wjNabpLWfs`;
      const response = await axios.get(url, reqoptions);

      if (response?.data.success === true) {
        // toast.success(response?.data?.message);

        return response.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        const body = {};
        dispatch(ReGenerateToken(GetPoolDataPrize, body, dispatch));
        return;
      }
      toast.error(
        error?.response?.data?.message ||
          error?.response?.message ||
          "Something went wrong"
      );
    } finally {
      dispatch(SetLoading(false));
    }
  };
};

/////////////////////////// AIRDROP API////////////////////////
export const airdropAPI = ({ payload }) => {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      const url = `${process.env.REACT_APP_apiBaseUrlSolana}/solana/api/airdrop`;

      const response = await axios.post(url, payload, reqoptions);

      if (response?.data) {
        dispatch(GenerateWalletDEtailBalance());

        return response.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(GetWeePointDetail());

      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        const body = {};
        dispatch(ReGenerateToken(restoreWeePoints, body, dispatch));
        return;
      }
      toast.error(
        error?.response?.data?.message ||
          error?.response?.message ||
          "Something went wrong"
      );
    } finally {
      dispatch(SetLoading(false));
    }
  };
};
export const TokenSwapAPI = ({ payload }) => {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      const url = `${process.env.REACT_APP_apiBaseUrlSolana}/solana/api/token-swap/raydium`;

      const response = await axios.post(url, payload, reqoptions);

      if (response?.data) {
        dispatch(GenerateWalletDEtailBalance());

        return response.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        const body = {};
        dispatch(ReGenerateToken(TokenSwapAPI, body, dispatch));
        return;
      }
      toast.error(
        error?.response?.data?.message ||
          error?.response?.message ||
          "Something went wrong"
      );
    } finally {
      dispatch(SetLoading(false));
    }
  };
};

export const restoreWeePoints = () => {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      const url = `${process.env.REACT_APP_apiBaseUrlSolana}/weepoints/restore-streaks`;

      const response = await axios.get(url, reqoptions);

      if (response?.data) {
        dispatch(GetWeePointDetail());

        return response.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        const body = {};
        dispatch(ReGenerateToken(restoreWeePoints, body, dispatch));
        return;
      }
      toast.error(
        error?.response?.data?.message ||
          error?.response?.message ||
          "Something went wrong"
      );
    } finally {
      dispatch(SetLoading(false));
    }
  };
};

export function Leaderboard({ type }) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      const url = `${process.env.REACT_APP_apiBaseUrlSolana}/weepoints/badge/get-leaderboard-data?type=${type}`;
      const response = await axios.get(url, reqoptions);

      if (response?.data) {
        return response.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        const body = { type };
        dispatch(ReGenerateToken(Leaderboard, body, dispatch));
        return;
      }
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export const WeePointsHistoryAPI = ({
  limit,
  type,
  dateFilter,
  fromDate,
  toDate,
}) => {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      let url = "";

      if (fromDate && toDate) {
        url = `${process.env.REACT_APP_apiBaseUrl}/weepoints/user-weepoint-history?limit=${limit}&type=${type}&startDate=${fromDate}&endDate=${toDate}`;
      } else {
        url = `${process.env.REACT_APP_apiBaseUrl}/weepoints/user-weepoint-history?limit=${limit}&type=${type}&dateFilter=${dateFilter}`;
      }

      const response = await axios.get(url, reqoptions);

      if (response?.data) {
        return response.data;
      } else {
        dispatch(SetLoading(false));
        // toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        const body = { limit, type, dateFilter, fromDate, toDate };
        dispatch(ReGenerateToken(WeePointsHistoryAPI, body, dispatch));
        return;
      }
      // toast.error(error?.response?.data?.message || error?.response?.message || "Something went wrong");
    } finally {
      dispatch(SetLoading(false));
    }
  };
};

////////////////// Referral.js API ///////////////////////

export const GetReferrralCodeAPI = ({ email, reference_number }) => {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      // const url = `${process.env.REACT_APP_apiBaseUrlSolana}/weepoints/collect-weepoints`;
      const url = `${process.env.REACT_APP_apiBaseUrl}/api/v1/getReferralCode?email=${email}&reference_number=${reference_number}`;
      const response = await axios.get(url, reqoptions);

      if (response?.data) {
        return response.data;
      } else {
        dispatch(SetLoading(false));
        // toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        const body = { email, reference_number };
        dispatch(ReGenerateToken(GetReferrralCodeAPI, body, dispatch));
        return;
      }
      // toast.error(error?.response?.data?.message || error?.response?.message || "Something went wrong");
    } finally {
      dispatch(SetLoading(false));
    }
  };
};

export const CheckGmailExist = ({ email }) => {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      // const url = `${process.env.REACT_APP_apiBaseUrlSolana}/weepoints/collect-weepoints`;
      const url = `${process.env.REACT_APP_apiBaseUrl}/api/v1/gmailExist`;
      const response = await axios.post(url, { email }, reqoptions);

      if (response?.data) {
        return response.data;
      } else {
        dispatch(SetLoading(false));
        // toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        const body = { email };
        dispatch(ReGenerateToken(CheckGmailExist, body, dispatch));
        return;
      }
      // toast.error(error?.response?.data?.message || error?.response?.message || "Something went wrong");
    } finally {
      dispatch(SetLoading(false));
    }
  };
};

////////////////// USER LOGS DETAILS
export const PostClientSideLogs = () => {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      const url = `${process.env.REACT_APP_apiBaseUrl}/weepoints/userlogs`;

      const response = await axios.get(url, reqoptions);

      if (response?.data) {
        return response.data;
      } else {
        dispatch(SetLoading(false));
        // toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        const body = {};
        dispatch(ReGenerateToken(PostClientSideLogs, body, dispatch));
        return;
      }
      // toast.error(error?.response?.data?.message || error?.response?.message || "Something went wrong");
    } finally {
      dispatch(SetLoading(false));
    }
  };
};

export const GetClientSideLogsDetails = () => {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      const url = `${process.env.REACT_APP_apiBaseUrl}/weepoints/userlogsdetails`;

      const response = await axios.get(url, reqoptions);

      if (response?.data) {
        return response.data;
      } else {
        dispatch(SetLoading(false));
        // toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        const body = {};
        dispatch(ReGenerateToken(GetClientSideLogsDetails, body, dispatch));
        return;
      }
      // toast.error(error?.response?.data?.message || error?.response?.message || "Something went wrong");
    } finally {
      dispatch(SetLoading(false));
    }
  };
};

// ----------------------------------GOOGLE EVENT API-----------------------------------------

export const CreateEvent = (payload) => {
  const token = GetDecryptAccessTokenformat();
  const referenceNumber = GetDecryptReferenceNumberformat();
  const email = GetDecryptEmailformat();

  return async (dispatch) => {
    try {
      dispatch(SetLoading(true));

      const url = `${process.env.REACT_APP_apiBaseUrl}/google-api/create_event`;

      const formData = new FormData();
      formData.append("email", email);
      formData.append("reference_number", referenceNumber);
      formData.append("event", JSON.stringify(payload.event));

      const response = await axios.post(url, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      if (response?.data) {
        dispatch(ListingGoogleEvents({ dispatch }));
        return;
      }
    } catch (error) {
      dispatch(SetLoading(false));

      if (error?.response?.status === 401) {
        dispatch(ReGenerateToken(CreateEvent, { payload }, dispatch));
        return;
      }

      throw error;
    } finally {
      dispatch(SetLoading(false));
    }
  };
};

export const UpdateEvent = (payload, dispatch) => {
  const token = GetDecryptAccessTokenformat();
  const referenceNumber = GetDecryptReferenceNumberformat();
  const email = GetDecryptEmailformat();

  return async (dispatch) => {
    try {
      dispatch(SetLoading(true));

      const url = `${process.env.REACT_APP_apiBaseUrl}/google-api/update_event`;

      const formData = new FormData();
      formData.append("email", email);
      formData.append("reference_number", referenceNumber);
      formData.append("event_id", payload.event_id);
      formData.append("updates", JSON.stringify(payload.updates));

      const response = await axios.post(url, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      if (response?.data) {
        dispatch(ListingGoogleEvents({ dispatch }));
        return;
      }
    } catch (error) {
      dispatch(SetLoading(false));

      if (error?.response?.status === 401) {
        dispatch(ReGenerateToken(UpdateEvent, { payload }, dispatch));
        return;
      }

      throw error;
    } finally {
      dispatch(SetLoading(false));
    }
  };
};

// --------------------------GOOGLE DRAFT API----------------------------------------

export const CreateGoogleDraftEmail = ({ payload }) => {
  const token = GetDecryptAccessTokenformat();
  const referenceNumber = GetDecryptReferenceNumberformat();
  const email = GetDecryptEmailformat();

  return async (dispatch) => {
    try {
      dispatch(SetLoading(true));

      const url = `${process.env.REACT_APP_apiBaseUrl}/google-api/create_draft`;

      const formData = new FormData();
      formData.append("email", email);
      formData.append("reference_number", referenceNumber);
      formData.append("to", payload?.to);
      formData.append("subject", payload?.subject);
      formData.append("body", payload?.body);

      const response = await axios.post(url, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      dispatch(GetGoogleDraftList());

      return response.data;
    } catch (error) {
      dispatch(SetLoading(false));

      if (error?.response?.status === 401) {
        dispatch(
          ReGenerateToken(CreateGoogleDraftEmail, { payload }, dispatch)
        );
        return;
      }

      throw error;
    } finally {
      dispatch(SetLoading(false));
    }
  };
};

export const DeleteGoogleDraftEmail = ({ payload }) => {
  const token = GetDecryptAccessTokenformat();
  const referenceNumber = GetDecryptReferenceNumberformat();
  const email = GetDecryptEmailformat();

  const obj = {
    email: email,
    reference_number: referenceNumber,
    message_id: payload?.draft_id,
  };

  return async (dispatch) => {
    try {
      dispatch(SetLoading(true));

      const url = `${process.env.REACT_APP_apiBaseUrl}/google-api/trash_email`;

      const response = await axios.post(url, obj, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      dispatch(GetGoogleDraftList());

      return response.data;
    } catch (error) {
      dispatch(SetLoading(false));

      if (error?.response?.status === 401) {
        dispatch(
          ReGenerateToken(DeleteGoogleDraftEmail, { payload }, dispatch)
        );
        return;
      }

      throw error;
    } finally {
      dispatch(SetLoading(false));
    }
  };
};

export const GetGoogleDraftList = () => {
  const token = GetDecryptAccessTokenformat();
  const referenceNumber = GetDecryptReferenceNumberformat();
  const email = GetDecryptEmailformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      const url = `${process.env.REACT_APP_apiBaseUrl}/google-api/list_drafts?email=${email}&reference_number=${referenceNumber}`;

      const response = await axios.get(url, reqoptions);

      if (response?.data) {
        dispatch(HandleGoogleDraft(response?.data?.data));

        return response.data;
      } else {
        dispatch(SetLoading(false));
        // toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        const body = {};
        dispatch(ReGenerateToken(GetGoogleDraftList, body, dispatch));
        return;
      }
      // toast.error(error?.response?.data?.message || error?.response?.message || "Something went wrong");
    } finally {
      dispatch(SetLoading(false));
    }
  };
};

export const SendGoogleDraftEmail = ({ payload }) => {
  const token = GetDecryptAccessTokenformat();
  const referenceNumber = GetDecryptReferenceNumberformat();
  const email = GetDecryptEmailformat();

  return async (dispatch) => {
    try {
      dispatch(SetLoading(true));

      const url = `${process.env.REACT_APP_apiBaseUrl}/google-api/send_draft`;

      const formData = new FormData();
      formData.append("email", email);
      formData.append("reference_number", referenceNumber);
      formData.append("draft_id", payload?.draft_id);

      const response = await axios.post(url, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      dispatch(GetGoogleDraftList());

      return response.data;
    } catch (error) {
      dispatch(SetLoading(false));

      if (error?.response?.status === 401) {
        dispatch(
          ReGenerateToken(CreateGoogleDraftEmail, { payload }, dispatch)
        );
        return;
      }

      throw error;
    } finally {
      dispatch(SetLoading(false));
    }
  };
};

// ---------------------------------------AI CREDITS TRANSACTIONS------------------------------------------
export const AICreditTokenHistoryAPI = ({
  page,
  limit,
  type,
  fromDate,
  toDate,
}) => {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      let url = "";

      if (fromDate && toDate) {
        url = `${process.env.REACT_APP_apiBaseUrl}/solana/api/credit/user-credits-transaction?page=${page}&limit=${limit}&type=${type}&startDate=${fromDate}&endDate=${toDate}`;
      } else {
        url = `${process.env.REACT_APP_apiBaseUrl}/solana/api/credit/user-credits-transaction?page=${page}&limit=${limit}&type=${type}`;
      }

      const response = await axios.get(url, reqoptions);

      if (response?.data) {
        dispatch(HandleAICreditTransactions(response?.data));
        return response.data;
      } else {
        dispatch(SetLoading(false));
        // toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        const body = { page, limit, type, fromDate, toDate };
        dispatch(ReGenerateToken(AICreditTokenHistoryAPI, body, dispatch));
        return;
      }
      // toast.error(error?.response?.data?.message || error?.response?.message || "Something went wrong");
    } finally {
      dispatch(SetLoading(false));
    }
  };
};

export const AICreditUsageAPI = () => {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_apiBaseUrl}/solana/api/credit/user-credits-usage`,
        reqoptions
      );

      if (response?.data) {
        dispatch(HandleAICreditUsage(response?.data));
        return response.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        dispatch(ReGenerateToken(AICreditUsageAPI, {}, dispatch));
        return;
      }
    }
  };
};

export const GetUserBadges = ({
  filter,
  page = 1,
  limit = 10,
  startDate,
  endDate,
} = {}) => {

  
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      const params = { page, limit };

      if (startDate && endDate) {
        params.startDate = startDate;
        params.endDate = endDate;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_apiBaseUrl}/weepoints/user-all-badges?filter=${filter||""}`,
        {
          ...reqoptions,
          params,
          
        }
      );

      if (response?.data) {
        dispatch(HandleAllGetUserBadgesDetails(response?.data));
        return response.data;
      } else {
        dispatch(SetLoading(false));
        // toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        const body = { page, limit, startDate, endDate };
        dispatch(ReGenerateToken(GetUserBadges, body, dispatch));
        return;
      }
      // toast.error(error?.response?.data?.message || error?.response?.message || "Something went wrong");
    } finally {
      dispatch(SetLoading(false));
    }
  };
};



